import React, { useContext, useMemo, useState, useRef, useEffect, useCallback, useLayoutEffect } from "react";
import {
  Row,
  Col,
  Button,
  Spinner,
  Toast,
  ToastContainer,
  Modal,
  Form,
  Dropdown,
  ButtonGroup,
  Table,
} from "react-bootstrap";
import { createPortal } from "react-dom";
import ReactSpeedometer from "react-d3-speedometer";
import { 
  PieChart, 
  Pie, 
  Cell, 
  ResponsiveContainer, 
  Tooltip, 
  Legend 
} from 'recharts';

import { ScoreContext } from "./ScoreContext.jsx";
import "../ComponentsCss/SecurityModel.css";
import "bootstrap/dist/css/bootstrap.min.css";
import BackgroundFooter from "./BackgroundFooter.jsx";
import Menubar from "./Menubar.jsx";
import axios from "axios";
import { useForm } from "./FormProvider.jsx";
import { Tabs, Tab } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import ActionPlan from "./Actionplan.jsx";
import Sponsor from "./Sponsor.jsx";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
// import Homepage from "./Homepage.jsx";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import InternalInvite from "./InternalInvite.jsx";
import GlobalRiskOverview from "./GlobalRiskOverview.jsx";
import NavigationBar from "./Nav";
import AvoidableLossCalculator from './AvoidableLossCalculator';
import { jsPDF } from "jspdf";              // client-side PDF generator
import html2canvas from "html2canvas";       // turns DOM → canvas
import autoTable from "jspdf-autotable";     // paginated tables
import logoImg from '../Assets/logo - Colored Background (1).png'; 
import { useAuth } from "../contexts/AuthContext";
// import ManagedRisks from './ManagedRisks';
import AvoidableLossWidget from './AvoidableLossWidget.jsx'
import SmoothSpeedometer from "./SmoothSpeedometer.jsx";
import { useNotification } from "../contexts/NotificationContext.jsx";
import useTrustStore from "../store/useTrustStore";
import { logActivity ,getClientIP } from '../utils/activityLogApi';
import RiskOwnerSection from "./RiskOwnerSection";
import ResizableTable from "./ResizableTable.jsx";
import ManualRisk from "./ManualRisk";


const SecurityModel = ({ userData ,data}) => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(
    () => JSON.parse(localStorage.getItem("isSidebarCollapsed")) || false
  );
  const { scoreData, responses, fetchResponsesForSection, overviewData,  cscrfChecklistData,
  updateCSCRFChecklist,
  saveCSCRFChecklistToBackend,
  fetchCSCRFChecklist, } =
    useContext(ScoreContext);
  const { formData } = useForm();
  const [showToast, setShowToast] = useState(false);
 
  const [toastMessage, setToastMessage] = useState("");
  const [aiInsights, setAiInsights] = useState([]);
  const [insightsLoading, setInsightsLoading] = useState(false);
  const [showSubmitPopup, setShowSubmitPopup] = useState(false);
  const [previousCriticalRiskIds, setPreviousCriticalRiskIds] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
const [loadingFiles, setLoadingFiles] = useState(false);
const [downloadingFile, setDownloadingFile] = useState(null);
// Add these state variables after your existing useState declarations
const [showDownloadModal, setShowDownloadModal] = useState(false);
const [isGeneratingReport, setIsGeneratingReport] = useState(false);
const [assetData, setAssetData] = useState([]);
const [assetCurrency, setAssetCurrency] = useState("USD");
const [liveInsights, setLiveInsights] = useState([]);
const [realtimeStatus, setRealtimeStatus] = useState(false);
const [lastInsightUpdate, setLastInsightUpdate] = useState(null);
const [criticalRiskCount, setCriticalRiskCount] = useState(0);
  const [showControlPicker, setShowControlPicker] = useState(false);
const [controlPickerRiskId, setControlPickerRiskId] = useState(null);
  const [activeTab, setActiveTab] = useState(() => {
    return localStorage.getItem("activeSecurityTab") || "risk";
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [showReminderModal, setShowReminderModal] = useState(false);
  const [selectedReminderItem, setSelectedReminderItem] = useState(null);
  const [reminderDate, setReminderDate] = useState("");
  const userId = userData?.["cognito:username"];
  const [fullAIResponse, setFullAIResponse] = useState({}); // Store full response
  const [reportList, setReportList] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [assessmentHistory, setAssessmentHistory] = useState([]);
  const [lastEvaluatedKey, setLastEvaluatedKey] = useState(null); // 👈 Track pagination key
  const [hasMoreHistory, setHasMoreHistory] = useState(true); // 👈 Track more data

  const [loadingHistory, setLoadingHistory] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);
  const [showReportModal, setShowReportModal] = useState(false);
  const [expandedIndex, setExpandedIndex] = useState(null);
  // const [acceptedRisks, setAcceptedRisks] = useState([]);
  const [insightStatus, setInsightStatus] = useState("Pending");
  const fileInputRef = useRef(null);
  const fileRefs = useRef([]);
  const hasLoadedOnce = useRef(false); // 👈 Add this
  const [pollingActive, setPollingActive] = useState(false);
  const [assessmentProgress, setAssessmentProgress] = useState(0);
  const [assessmentProgressMessage, setAssessmentProgressMessage] = useState("");
  // const [submittingIndex, setSubmittingIndex] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [helpMessage, setHelpMessage] = useState("");
  const [sending, setSending] = useState(false);
  const [uploadedRisks, setUploadedRisks] = useState([]);
const [riskFilter, setRiskFilter] = useState("all"); // all | ai | uploaded
const [cacheFetching, setCacheFetching] = useState(false);
const [showEmailModal, setShowEmailModal] = useState(false);
const [emailAddress, setEmailAddress] = useState(userData?.email || '');
const [isDownloadingPDF, setIsDownloadingPDF] = useState(false);
const [isEmailingPDF, setIsEmailingPDF] = useState(false);
const [liveInsightsLoading, setLiveInsightsLoading] = useState(false);
// const [loadingAcceptedRisks, setLoadingAcceptedRisks] = useState(false);
const [updatingRisk, setUpdatingRisk] = useState(null);
const [uploadingFile, setUploadingFile] = useState(null);
const [assigningAdmin, setAssigningAdmin] = useState(null);
const [generatingSteps, setGeneratingSteps] = useState(null);
const [removingRisk, setRemovingRisk] = useState(null);
const [lastUpdated, setLastUpdated] = useState(null);
const [deletingFile, setDeletingFile] = useState(null);
const { profile } = useAuth();
// Add to your existing state variables
const [previousScore, setPreviousScore] = useState(null);
const [scoreChange, setScoreChange] = useState(null);
const [scoreTrend, setScoreTrend] = useState(null); // 'up', 'down', or 'stable'
const [showDeleteModal, setShowDeleteModal] = useState(false);
const [fileToDelete, setFileToDelete] = useState(null);
// const [addedManagedRisks, setAddedManagedRisks] = useState(new Set());
const {
  emailNotificationEnabled,
  pushNotificationEnabled,
  userPhoneNumber,
  lastNotificationSent,
  sendCriticalRiskNotification,
  setUserPhoneNumber,
} = useNotification();
const [allControls, setAllControls] = useState([]);
const [loadingControls, setLoadingControls] = useState(false);
const [selectedRisk, setSelectedRisk] = useState(null);
const [showRiskPanel, setShowRiskPanel] = useState(false);
const [highlightedRiskId, setHighlightedRiskId] = useState(null);
// const [showManageModal, setShowManageModal] = useState(false);
// const [riskAction, setRiskAction] = useState('');



const [mapControlRiskId, setMapControlRiskId] = useState(null);

  const userName = userData?.name;
  const userEmail = userData?.email;
  const userPhone = userData?.phone_number || "N/A"; // if you're storing phone
  const toggleInsight = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };
  const [genAiRisks, setGenAiRisks] = useState([]);
const [allRisks, setAllRisks] = useState([]);
const [aiIdentifiedRisks, setAiIdentifiedRisks] = useState([]);

const navigate = useNavigate();
const [clientIP, setClientIP] = useState('');
useEffect(() => {
  getClientIP().then(ip => setClientIP(ip || '')).catch(() => setClientIP(''));
}, []);

const [manualRisks, setManualRisks] = useState([]);
const [processedManualRisks, setProcessedManualRisks] = useState([]);



const [phoneNumberSaved, setPhoneNumberSaved] = useState(false);
const [isUpdatingPhone, setIsUpdatingPhone] = useState(false);
// Add these state variables with your other useState declarations
const [realtimeEnabled, setRealtimeEnabled] = useState(() => {
  const saved = localStorage.getItem(`realtimeEnabled_${userId}`);
  return saved ? JSON.parse(saved) : false;
});

const [toggleLoading, setToggleLoading] = useState(false);
// Share Dashboard States (updated)
const [showShareModal, setShowShareModal] = useState(false);
const [shareEmail, setShareEmail] = useState('');
const [sharingInProgress, setSharingInProgress] = useState(false);
const [sharedUsers, setSharedUsers] = useState([]);
const [loadingSharedUsers, setLoadingSharedUsers] = useState(false);
const orgId = profile?.orgId;
// Checklist for what to share
const [shareOptions, setShareOptions] = useState({
  riskRegister: true,
  recommendedModules: true,
  securityScore: true,
  avoidableLoss: true,
  thirdPartyCollaboration: true,
  internalInvites: true,
  reporting: true
});




const DASHBOARD_ENDPOINTS = {

 
  share: `https://h5bzla57u2.execute-api.ap-southeast-2.amazonaws.com/prod/api/dashboard/share`,
  sharedUsers: `https://7d0hg4x2l9.execute-api.ap-southeast-2.amazonaws.com/prod/api/dashboard/shared-users`,
  revokeShare: `https://2xnax0cm97.execute-api.ap-southeast-2.amazonaws.com/prod/api/dashboard/revoke-share`
};

const handleSidebarToggle = () => setIsSidebarCollapsed((prev) => !prev);






useEffect(() => {
  localStorage.setItem('pushNotificationEnabled', JSON.stringify(pushNotificationEnabled));
}, [pushNotificationEnabled]);

// Initialize phone number from localStorage on component mount
useEffect(() => {
  const savedPhone = localStorage.getItem('userPhoneNumber');
  if (savedPhone && !userPhoneNumber) {
    setUserPhoneNumber(savedPhone);
    setPhoneNumberSaved(true);
  }
}, []);

useEffect(() => {
  document.body.style.overflow = showDeleteModal ? "hidden" : "auto";
}, [showDeleteModal]);

// ---------- answered-only helpers ----------
const isBlank = (v) => v === undefined || v === null || String(v).trim() === "";
const isNA = (v) => String(v).trim().toUpperCase() === "NA";
const hasAnswer = (q) => {
  const v = q?.selectedOption ?? q?.answer ?? q?.value;
  return !(isBlank(v) || isNA(v));
};
const isQuestionLike = (o) => o && typeof o === "object" && ("question" in o || "questionText" in o);

// keep only answered questions (or parents with any answered sub-qs)
const pruneQuestionsAnsweredOnly = (arr = []) =>
  arr.map((q) => {
      const keptSub = pruneQuestionsAnsweredOnly(q?.subQuestions || []);
      const keepThis = hasAnswer(q) || keptSub.length > 0;
      if (!keepThis) return null;
      const copy = { ...q };
      if (keptSub.length > 0) copy.subQuestions = keptSub; else delete copy.subQuestions;
      return copy;
    })
    .filter(Boolean);

// overview: drop blanks from overviewQuestions + questions
const filterOverviewAnsweredOnly = (overview = {}) => {
  const out = { ...(overview || {}) };
  if (Array.isArray(out.overviewQuestions)) {
    out.overviewQuestions = out.overviewQuestions.filter((q) => hasAnswer(q));
  }
  if (Array.isArray(out.questions)) {
    out.questions = pruneQuestionsAnsweredOnly(out.questions);
  }
  return out;
};

// responses: handle both arrays and section maps (your current shape is a map)
const filterResponsesAnsweredOnly = (all = {}) => {
  const result = {};
  for (const [section, items] of Object.entries(all || {})) {
    if (Array.isArray(items)) {
      const kept = pruneQuestionsAnsweredOnly(items);
      if (kept.length > 0) result[section] = kept;
    } else if (items && typeof items === "object") {
      const keptObj = {};
      for (const [qid, obj] of Object.entries(items)) {
        if (hasAnswer(obj)) keptObj[qid] = obj;
      }
      if (Object.keys(keptObj).length > 0) result[section] = keptObj;
    }
  }
  return result;
};

// formData: walk everything; keep only answered question-like nodes
const PRESERVE_ALWAYS = new Set(["attachmentFileNames","evidence","files","uploadedFiles","policyFileName","hasAttachment","attachmentNote","recommendation","type","category","subId"]);
const sanitizeFormDataAnsweredOnly = (data) => {
  const visit = (node) => {
    if (Array.isArray(node)) {
      if (node.length && node.every((x) => isQuestionLike(x))) {
        return pruneQuestionsAnsweredOnly(node);
      }
      const arr = node.map(visit).filter((v) => v !== undefined && !(Array.isArray(v) && v.length === 0));
      return arr.length ? arr : undefined;
    }
    if (node && typeof node === "object") {
      if (isQuestionLike(node)) {
        const keptSub = pruneQuestionsAnsweredOnly(node.subQuestions || []);
        if (!hasAnswer(node) && keptSub.length === 0) return undefined;
        const copy = { ...node };
        if (keptSub.length > 0) copy.subQuestions = keptSub; else delete copy.subQuestions;
        return copy;
      }
      const out = {};
      for (const [k, v] of Object.entries(node)) {
        if (PRESERVE_ALWAYS.has(k)) { out[k] = v; continue; }
        if (k === "questions" && Array.isArray(v)) {
          const kept = pruneQuestionsAnsweredOnly(v);
          if (kept.length > 0) out[k] = kept;
          continue;
        }
        const child = visit(v);
        if (child !== undefined && !(Array.isArray(child) && child.length === 0) && !(child && typeof child === "object" && !Array.isArray(child) && Object.keys(child).length === 0)) {
          out[k] = child;
        }
      }
      return Object.keys(out).length ? out : undefined;
    }
    return node;
  };
  return visit(JSON.parse(JSON.stringify(data || {}))) ?? {};
};

// final builder: answered-only
const buildAnsweredOnlyPayload = ({ userId, overviewData, responses, formData, token, vendor,susanGenieData , cscrfChecklistData, orgId }) => ({
  userId,
  orgId,
  overviewData: { ...filterOverviewAnsweredOnly(overviewData), token, vendor },
  responses: filterResponsesAnsweredOnly(responses),
  formData: sanitizeFormDataAnsweredOnly(formData),
  //  ...(susanGenieData && { susanGenieData }),
  //   cscrfChecklistData: cscrfChecklistData
  susanGenieData: susanGenieData,  // ✅ FIXED: Remove the spread operator
  cscrfChecklistData: cscrfChecklistData,
   manualRisks: manualRisks ?? []  
});

const fetchAllControlsForPicker = async () => {
  setLoadingControls(true);
  try {
    const { domains } = useTrustStore.getState();

    // If domains not loaded yet, fetch them first
    let domainList = domains;
    if (!domainList || domainList.length === 0) {
      const region = sessionStorage.getItem("userRegion") || "GB";
      const res = await axios.get(
         `https://ndm4c2vvsl.execute-api.ap-southeast-2.amazonaws.com/prod/api/trust/domains`,
        { params: { orgId: profile?.orgId, primaryOnly: true } }
      );
      domainList = res.data?.domains || [];
    }

    // Fetch controls for each domain in parallel
    const results = await Promise.allSettled(
      domainList.map(domain =>
        axios.get(
           `https://jzlfh10d1j.execute-api.ap-southeast-2.amazonaws.com/prod/api/trust/domain/${domain.domainId}/controls?primaryOnly=true`,
//           {
          {
            headers: {
              "X-Region": sessionStorage.getItem("userRegion") || "GB",
              "X-Org-Id": profile?.orgId,
            }
          }
        )
      )
    );

    const controls = results
      .filter(r => r.status === "fulfilled")
      .flatMap(r => r.value.data?.controls || []);

    setAllControls(controls);
  } catch (err) {
    console.error("Failed to fetch all controls:", err);
  } finally {
    setLoadingControls(false);
  }
};

// Share dashboard with comprehensive data
const handleShareDashboard = async () => {
  // Validation checks
  if (!shareEmail || !shareEmail.includes('@')) {
    setToastMessage('Please enter a valid email address');
    setShowToast(true);
    return;
  }
  
  if (shareEmail === userData?.email) {
    setToastMessage('You cannot share the dashboard with yourself');
    setShowToast(true);
    return;
  }
  
  // Check if at least one share option is selected
  if (!Object.values(shareOptions).some(v => v)) {
    setToastMessage('Please select at least one data category to share');
    setShowToast(true);
    return;
  }
  
  setSharingInProgress(true);
  
  try {
    // ✅ Simplified payload - backend fetches live data
    const payload = {
      sharedBy: {
        userId: userData?.['cognito:username'],
        email: userData?.email,
        name: userData?.name,
        orgId: userData?.orgId || profile?.orgId,
        region: getUserRegion()  // ✅ REQUIRED by backend
      },
      sharedWith: shareEmail,
      shareOptions: shareOptions,  // Just the boolean flags
      sharedAt: new Date().toISOString()
    };
    
    console.log('Sharing dashboard with payload:', payload); // Debug log
    
    const response = await axios.post(
      DASHBOARD_ENDPOINTS.share,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          Region: getUserRegion()
        }
      }
    );
    
    if (response.status === 200) {
      // Build summary of what was shared
      const sharedItems = [];
      if (shareOptions.riskRegister) sharedItems.push('Risk Register');
      if (shareOptions.securityScore) sharedItems.push('Security Score');
      if (shareOptions.recommendedModules) sharedItems.push('Recommended Modules');
      if (shareOptions.avoidableLoss) sharedItems.push('Avoidable Loss');
      if (shareOptions.thirdPartyCollaboration) sharedItems.push('Third-Party Collaboration');
      if (shareOptions.internalInvites) sharedItems.push('Internal Invites');
      if (shareOptions.reporting) sharedItems.push('Reporting');
      
      setToastMessage(
        `Dashboard shared successfully with ${shareEmail}! Shared: ${sharedItems.join(', ')}`
      );
        logActivity({
            userData,
            orgId:       orgId,
            region:      sessionStorage.getItem('userRegion') || 'AP',
            module:      'Dashboard',
            category:    'Risk',
            action:      'Dashboard Shared',
            severity:    'success',

            description: `Dashboard shared with ${shareEmail}`,
          ipAddress:   clientIP});
      setShowToast(true);
      setShareEmail('');
      
      // Refresh shared users list
      fetchSharedUsers();
    }
  } catch (error) {
    console.error('Error sharing dashboard:', error);
    setToastMessage(
      error.response?.data?.message || 'Failed to share dashboard. Please try again.'
    );
    setShowToast(true);
  } finally {
    setSharingInProgress(false);
  }
};




// Fetch list of users this dashboard is shared with
const fetchSharedUsers = async () => {
  if (!userId) return;
  
  setLoadingSharedUsers(true);
  try {
    const response = await axios.get(
      DASHBOARD_ENDPOINTS.sharedUsers,
      {
        params: { userId },
        headers: { Region: getUserRegion() }
      }
    );
    
    if (response.status === 200) {
      setSharedUsers(response.data.sharedUsers || []);
    }
  } catch (error) {
    console.error('Failed to fetch shared users:', error);
    setToastMessage('Failed to load shared users');
    setShowToast(true);
  } finally {
    setLoadingSharedUsers(false);
  }
};


// Undo/Remove sharing
const handleUndoShare = async (sharedUserId, sharedUserEmail) => {
  if (!window.confirm(`Remove dashboard access for ${sharedUserEmail}?`)) {
    return;
  }
  console.log("Id",sharedUserId)
  try {
    const response = await axios.delete(
      DASHBOARD_ENDPOINTS.revokeShare,
      {
        params: {
          userId: userData?.['cognito:username'],
          shareId: sharedUserId
        },
        headers: { Region: getUserRegion() }
      }
    );
    
    if (response.status === 200) {
      setToastMessage(`Access removed for ${sharedUserEmail}`);
      logActivity({
            userData,
            orgId:       orgId,
            region:      sessionStorage.getItem('userRegion') || 'AP',
            module:      'Dashboard',
            category:    'Risk',
            action:      'Dashboard Access Revoked',
            severity:    'success',
            description: `Dashboard access revoked for ${sharedUserEmail}`,});
      setShowToast(true);
      
      // Refresh shared users list
      fetchSharedUsers();
    }
  } catch (error) {
    console.error('Error removing share:', error);
    setToastMessage(
      error.response?.data?.message || 'Failed to remove access. Please try again.'
    );
    setShowToast(true);
  }
};


// Load shared users on component mount
useEffect(() => {
  if (userId) {
    fetchSharedUsers();
  }
}, [userId]);


// Add this function with your other functions
const fetchAssetData = async () => {
  if (!orgId) return;
  
  try {
    const response = await axios.get(
       "https://hwul63huka.execute-api.ap-southeast-2.amazonaws.com/prod/api/assets/get-by-user",
      {
        params: { orgId },
        headers: { Region: getUserRegion() },
      }
    );

    console.log("Asset API response:", response.data);
    console.log("Asset API status:", response.status);
    setAssetData(response.data || []);
  } catch (error) {
    console.error("Failed to fetch asset data:", error);
    setAssetData([]);
  }
};



// Add useEffect to fetch asset data on component mount
useEffect(() => {
  if (userId) {
    fetchAssetData();
  }
}, [userId]);


// Add this function near your other API functions
const fetchAndCacheAIInsights = async (forceRefresh = false) => {
  if (!userId) return;
 setCacheFetching(true); 
  try {
    console.log("🔍 Fetching AI insights for userId:", userId);
    
    // Check cache first (unless forcing refresh)
    if (!forceRefresh) {
      const cachedInsights = localStorage.getItem("aiInsights");
      const cachedTimestamp = localStorage.getItem("aiInsightsTimestamp");
      const cachedFullResponse = localStorage.getItem("fullAIResponse");
      
      // Use cached data if it exists and is less than 1 hour old
      if (cachedInsights && cachedTimestamp && cachedFullResponse) {
        const cacheAge = Date.now() - parseInt(cachedTimestamp);
        const oneHour = 60 * 60 * 1000;
        
        if (cacheAge < oneHour) {
          const insights = JSON.parse(cachedInsights);
          const fullResponse = JSON.parse(cachedFullResponse);
          
          setAiIdentifiedRisks(insights);
          setFullAIResponse(fullResponse);
          setCacheFetching(false);
          return; // Exit early with cached data
        }
      }
    }
    
    console.log("🔄 Fetching AI insights from backend...");
    
    const response = await axios.get(
     "https://3wa9z2v1rf.execute-api.ap-southeast-2.amazonaws.com/prod/api/cached-ai-insights", // Update with your actual endpoint
      {
        params: { userId },
        headers: { Region: getUserRegion() }
      }
    );
    
    if (response.data.success && response.data.data) {
      const { insights, recommendedModules, score, timestamp } = response.data.data;
      
      if (insights && insights.length > 0) {
        // Sort insights by severity
        const sortedInsights = insights.sort((a, b) => {
          const severityOrder = { Critical: 4, High: 3, Medium: 2, Low: 1 };
          return (severityOrder[b.severity] || 0) - (severityOrder[a.severity] || 0);
        });
        
        // Create full response object
        const fullResponse = {
          insights: sortedInsights,
          recommendedModules: recommendedModules || [],
          score,
          timestamp
        };
        
        // Update state
        setAiIdentifiedRisks(sortedInsights);
        setFullAIResponse(fullResponse);
        
        // Cache the data with timestamp
        localStorage.setItem("aiInsights", JSON.stringify(sortedInsights));
        localStorage.setItem("fullAIResponse", JSON.stringify(fullResponse));
        localStorage.setItem("aiInsightsTimestamp", Date.now().toString());
        
        console.log("✅ AI insights fetched and cached successfully");
        
       
       
      } else {
        console.log("ℹ️ No AI insights found for user");
      }
    }
    
  } catch (error) {
    console.error("❌ Failed to fetch AI insights from backend:", error);
    
    // Fallback to localStorage if backend fails
    const cachedInsights = localStorage.getItem("aiInsights");
    const cachedFullResponse = localStorage.getItem("fullAIResponse");
    
    if (cachedInsights && cachedFullResponse) {
      console.log("🔄 Falling back to cached data");
      setAiIdentifiedRisks(JSON.parse(cachedInsights));
      setFullAIResponse(JSON.parse(cachedFullResponse));
    }
    } finally {
    setCacheFetching(false); // 🔥 ALWAYS END loading
  }
};

// Add this function right after your existing fetchAndCacheAIInsights function
const saveCachedAIInsights = async (aiData) => {
  if (!userId) return;
  
  try {
    console.log("💾 Saving AI insights to cache...");
    
    const payload = {
      userId: userId,
      insights: aiData?.insights || [],
      recommendedModules: aiData?.recommendedModules || [],
      score: scaledScore
    };
    
    const response = await axios.post(
      "https://dnrpz3p0ak.execute-api.ap-southeast-2.amazonaws.com/prod/api/cached-ai-insights", 
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          "Region": getUserRegion()
        }
      }
    );
    
    if (response.data.success) {
      console.log("✅ AI insights cached successfully to backend");
    }
    
  } catch (error) {
    console.error("❌ Failed to save AI insights to cache:", error);
  }
};

const fetchUploadedFiles = async () => {
  setLoadingFiles(true);
  try {
    const filesRes = await axios.get(
      `https://30jled4da5.execute-api.ap-southeast-2.amazonaws.com/prod/api/external-pdf/list`,
      { params: { email: userEmail, Region: getUserRegion() } }
    );
    
    setUploadedFiles(filesRes.data.files || filesRes.data).map(f => ({
    ...f,
    uploadedAt: f.uploadedAt || f.createdAt || f.lastModified || null,
  }));
  } catch (error) {
    console.error('Error fetching files:', error);
    // You can add toast notification here
  } finally {
    setLoadingFiles(false);
  }
};
const region = sessionStorage.getItem("userRegion") || "eu-west-1";


// Function to download a file
// For presigned URL approach
const handleDownloadFile = async (file) => {
  setDownloadingFile(file.fileName || file.name);
  try {
    const response = await axios.get(
      `https://ivfqhdjw72.execute-api.ap-southeast-2.amazonaws.com/prod/api/external-pdf/download-redirect`,
      {
        params: { 
          email: userEmail, 
          Region: region,
          fileName: file.fileName || file.name
        }
      }
    );

    // Use the presigned URL to download
    const link = document.createElement('a');
    link.href = response.data.downloadUrl;
    link.setAttribute('download', response.data.fileName);
    link.setAttribute('target', '_blank');
    document.body.appendChild(link);
    link.click();
    link.remove();
    
  } catch (error) {
    console.error('Error downloading file:', error);
  } finally {
    setDownloadingFile(null);
  }
};

const confirmDelete = (file) => {
    setFileToDelete(file);
    setShowDeleteModal(true);
};

const handleDeleteFile = async () => {
    if (!fileToDelete) return;
    const fileName = fileToDelete.fileName || fileToDelete.name;

    setShowDeleteModal(false);
    setDeletingFile(fileName);

    try {
        await axios.delete(
                        'https://9uxr3lqlfi.execute-api.ap-southeast-2.amazonaws.com/prod/api/external-pdf/delete',
            {
                params: {
                    email: userEmail,
                    Region: region,
                    fileName: fileName,
                },
            }
        );
        setToastMessage(`"${fileName}" deleted successfully.`);
         logActivity({
            userData,
            orgId:       orgId,
            region:      sessionStorage.getItem('userRegion') || 'AP',
            module:      'Dashboard',
            category:    'Access Reports',
            action:      'Pdf deleted',
            severity:    'success',
            description: ` ${fileName} deleted`,});
        setShowToast(true);
        await fetchUploadedFiles();
    } catch (error) {
        console.error('Error deleting file:', error);
        setToastMessage('Failed to delete file. Please try again.');
        setShowToast(true);
    } finally {
        setDeletingFile(null);
        setFileToDelete(null);
    }
};




// Call this function when component mounts or when you want to refresh
useEffect(() => {
  if (userEmail && region) {
    fetchUploadedFiles();
  }
}, [userEmail, region]);



const downloadSampleTemplate = () => {
  const sampleData = [
    {
      riskId: "RISK001",
      category: "Access Control",
       risk: "Unpatched software on all workstations increases exposure to external exploits. Immediate patching is required.",
      severity: "High",
      description: "No MFA for Admin Accounts", // Required column (alias for "risk")
      assetAffected: "Admin Console",
      threatSource: "Internal Threat",
      riskOwner: "IT Security",
      avoidableLoss: 15000, 
      reviewDate: new Date().toISOString().split("T")[0],
      recommendation: "Enable MFA for all admin users." // Required column
    },
    {
     riskId: "RISK002",
     category: "Access Management",
     risk: "Shared administrator accounts on critical systems limit accountability and increase the risk of unauthorized changes.",
     severity: "High",
     description: "Shared Admin Credentials in Production Servers",
     assetAffected: "Production Servers",
     threatSource: "Insider Threat / Misuse",
     riskOwner: "IT Operations",
     avoidableLoss: 32000, 
     reviewDate: new Date().toISOString().split("T")[0],
     recommendation: "Implement unique admin accounts with MFA and audit logging."
    }

  ];

  const ws = XLSX.utils.json_to_sheet(sampleData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "UploadedRisks");

  const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  saveAs(new Blob([wbout], { type: "application/octet-stream" }), "RiskUploadTemplate.xlsx");
};


const REQUIRED_COLUMNS = ["risk", "severity"];
const showToastMessage = (message, variant = "success") => {
  setToastMessage(message);
  setShowToast(true);
};

const handleRiskFileUpload = (e) => {
  const file = e.target.files[0];
  if (!file) {
    console.log("❌ No file selected.");
    return;
  }

  console.log("📁 File selected:", file.name);

  const reader = new FileReader();
  reader.onload = (evt) => {
    try {
      const data = new Uint8Array(evt.target.result);
      console.log("📦 File read into Uint8Array:", data);

      const workbook = XLSX.read(data, { type: "array" });
      console.log("📄 Workbook loaded. Sheets:", workbook.SheetNames);

      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      console.log("📊 Using sheet:", sheetName);

      const jsonData = XLSX.utils.sheet_to_json(worksheet);
      console.log("🧾 Parsed JSON data from sheet:", jsonData);

      if (jsonData.length === 0) {
        console.warn("⚠️ Uploaded file is empty.");
        showToastMessage("❌ The uploaded file is empty.", "danger");
        setShowToast(true);
        return;
      }

      // ✅ Validate column headers
      const fileColumns = Object.keys(jsonData[0]).map(col => col.trim().toLowerCase());
      console.log("📋 Columns in file:", fileColumns);

      const REQUIRED_COLUMNS = ["description", "severity", "category", "recommendation"];
      const missingColumns = REQUIRED_COLUMNS.filter(col => !fileColumns.includes(col));
      if (missingColumns.length > 0) {
        console.error("❌ Missing required columns:", missingColumns);
        showToastMessage(
          `❌ Missing column(s): ${missingColumns.join(", ")}`,
          "danger"
        );
        setShowToast(true);
        return;
      }

      // Optional: Normalize severity format
      const normalized = jsonData.map((row, index) => {
        const rawLoss = row.avoidableLoss ?? row["Avoidable Loss"] ?? row["avoidable_loss"] ?? "";
        const parsedLoss = rawLoss === "" ? "" : Number(rawLoss); // keep as number if possible, else text
        const normRow = {
          ...row,
          severity: row.severity?.charAt(0).toUpperCase() + row.severity?.slice(1).toLowerCase(),
        };
        console.log(`✅ Row ${index + 1}:`, normRow);
        return normRow;
      });

      const sortedUploaded = normalized.sort((a, b) => {
        const order = { Critical: 4, High: 3, Medium: 2, Low: 1 };
        return (order[b.severity] || 0) - (order[a.severity] || 0);
      });

     

      setUploadedRisks(sortedUploaded);
      showToastMessage("✅ Risks uploaded successfully!", "success");
      logActivity({
            userData,
            orgId:       orgId,
            region:      sessionStorage.getItem('userRegion') || 'AP',
            module:      'Dashboard',
            category:    'Risk',
            action:      'Risk uploaded',
            severity:    'success',
            description: `Risks uploaded successfully`});
      localStorage.setItem("uploadedRisks", JSON.stringify(sortedUploaded));
      setShowToast(true);
    } catch (err) {
      console.error("❌ File processing error:", err);
      showToastMessage("❌ Failed to process the file.", "danger");
    }
  };

  reader.readAsArrayBuffer(file);
};



const displayedRisks = useMemo(() => {
  if (realtimeEnabled) {
   
    if (liveInsights.length > 0) {
      const liveRisks = liveInsights.flatMap((insight, index) => {
        // Try to parse the JSON safely
        let parsedInsights = [];
        try {
          parsedInsights = insight.insights ? JSON.parse(insight.insights) : [];
        } catch (e) {
          console.warn("⚠️ Could not parse insights:", e);
        }

        // If no array returned, ensure it's an array
        if (!Array.isArray(parsedInsights)) {
          parsedInsights = [parsedInsights];
        }

        // Map every insight in this record
        return parsedInsights.map((ri, subIndex) => ({
          riskId: ri.riskId || `live-${index}-${subIndex}`,
          risk: ri.risk || "Live security alert detected",
          severity: ri.severity || insight.riskLevel || "MEDIUM",
          category: ri.category || insight.threatCategory || "Security Alert",
          recommendation: ri.recommendation || insight.recommendations || "Review alert details",
          assetAffected: ri.assetAffected || "Live System",
          threatSource: ri.threatSource || "Real-time Detection",
          riskOwner: ri.riskOwner || "Security Team",
          reviewDate: ri.reviewDate || new Date().toISOString().split("T")[0],
          timestamp: insight.timestamp,
          rawInsight: ri,
          parentInsightId: insight.alertId || `insight-${index}`
        }));
      });

      console.log("🔴 Live insights mapped:", liveRisks.length, "risks");
      return liveRisks;
    } else {
      console.log("🔴 No live insights available");
      return [];
    }
  }



  let risks = [];
  if (riskFilter === "ai") {
    risks = aiIdentifiedRisks;
  } else if (riskFilter === "uploaded") {
    risks = uploadedRisks;
  } else {
    risks = allRisks;
  }

  return risks;
}, [aiIdentifiedRisks, uploadedRisks, allRisks, riskFilter, realtimeEnabled, liveInsights]);





 const tableScrollRef = useRef(null);
const stickyScrollRef = useRef(null);
 
const autoLinkRisksToControls = async (insights) => {
  const { addRiskMapping, setProfile } = useTrustStore.getState();

  if (profile) setProfile(profile);

  // ✅ Domain → asset category fallback map
  const categoryMap = {
    "Cloud Security":         "Cloud Service",
    "Network Security":       "Network",
    "Application Security":   "Software",
    "Data Security":          "Data / Information",
    "Identity & Access":      "People",
    "Governance":             "Other",
    "Operational Resilience": "Hardware",
    "Privacy":                "Data / Information",
    "Third-Party Risk":       "Other",
    "OT/IoT Security":        "Hardware",
  };

  const globalMapped = new Set();

  for (const risk of insights) {
    if (!risk.linkedControls?.length) continue;

    // ✅ Try to match asset by name first, fall back to domain map
    const matchedAsset = assetData.find(a =>
      risk.assetAffected?.toLowerCase()
           .includes((a.assetName || "").toLowerCase())
    );

    const assetCategory = matchedAsset?.assetCategory
                       || categoryMap[risk.domain]
                       || "Other";

    for (const ctrl of risk.linkedControls) {
      const key = `${ctrl.controlId}-${risk.riskId}`;
      if (globalMapped.has(key)) continue;
      globalMapped.add(key);

      try {
        await addRiskMapping(ctrl.controlId, {
          riskId:        String(risk.riskId),
          riskName:      risk.risk || "",
          severity:      risk.severity || "",
          source:        "AI",
          addedBy:       userData?.email,
          addedByUserId: userData?.["cognito:username"],
          assetCategory: assetCategory,  // ✅ NEW
        });
        console.log("✅ Mapped:", ctrl.controlId, "←", risk.riskId,
                    "| category:", assetCategory);
      } catch (err) {
        console.error("Auto-link failed for", ctrl.controlId, err);
      }
    }
  }
};

useLayoutEffect(() => {
  const wrapper = tableScrollRef.current; 
  const sticky = stickyScrollRef.current;
  if (!wrapper || !sticky) return;

  const table = wrapper.querySelector("table");
  const track = sticky.querySelector(".scrollbar-track");
  if (!table || !track) return;

  const syncWidth = () => {
    const fullWidth = Math.max(
      table.scrollWidth,
      table.offsetWidth,
      table.getBoundingClientRect().width
    );
    track.style.width = `${fullWidth}px`;
  };

  const syncFromWrapper = () => {
    sticky.scrollLeft = wrapper.scrollLeft;
  };

  const syncFromSticky = () => {
    wrapper.scrollLeft = sticky.scrollLeft;
  };

  syncWidth();

  wrapper.addEventListener("scroll", syncFromWrapper);
  sticky.addEventListener("scroll", syncFromSticky);
  window.addEventListener("resize", syncWidth);

  const resizeObserver = new ResizeObserver(() => {
    syncWidth();
  });

  resizeObserver.observe(table);

  return () => {
    wrapper.removeEventListener("scroll", syncFromWrapper);
    sticky.removeEventListener("scroll", syncFromSticky);
    window.removeEventListener("resize", syncWidth);
    resizeObserver.disconnect();
  };
}, [displayedRisks]);


// Replace or modify your existing risk initialization
useEffect(() => {
  const merged = [
    ...uploadedRisks.map((risk) => ({ ...risk, source: "Uploaded" })),
    ...aiIdentifiedRisks.map((risk) => ({ ...risk, source: "GenAI" })),
  ];
  setAllRisks(merged);
}, [uploadedRisks, aiIdentifiedRisks]);

useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const riskId = params.get('riskId');
  if (riskId) {
    setHighlightedRiskId(riskId);
    setTimeout(() => setHighlightedRiskId(null), 3000);
    setTimeout(() => {
      const el = document.getElementById(`risk-row-${riskId}`);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 500);
  }
}, [displayedRisks]);

const handleAcceptRiskSubmit = async (item, index) => {
  const riskId = item.riskId;


  const formData = new FormData();
  formData.append("userId", userId);
  formData.append("region", getUserRegion());
  formData.append("orgId", userData?.orgId || profile?.orgId);
  formData.append("riskId", riskId);
  formData.append("category", item.category);
  formData.append("risk", item.risk);
  formData.append("severity", item.severity);

  if (item.assetAffected) formData.append("assetAffected", item.assetAffected);
  if (item.threatSource) formData.append("threatSource", item.threatSource);
  if (item.riskOwner) formData.append("riskOwner", item.riskOwner);
  if (item.recommendation) formData.append("recommendation", item.recommendation);
  if (item.reviewDate) formData.append("reviewDate", item.reviewDate);

  formData.append("visibility", "organization");
  formData.append("submittedBy", userData?.email);
  formData.append("submittedByName", userData?.name);
  formData.append("status", "active");


  try {
    await axios.post(
       "https://5gw5hsvnlb.execute-api.ap-southeast-2.amazonaws.com/prod/api/accepted-risk/submit",
      formData,
      { headers: {}, timeout: 30000 }
    );

    useTrustStore.getState().setProfile(profile);

    // ── Risk mapping only — NO treatment written here anymore ──
    // Treatment is now done inside TrustControlPage via the Treat panel
    if (item.linkedControls && item.linkedControls.length > 0) {
      const mappedControls = new Set();

      for (const ctrl of item.linkedControls) {
        const mapKey = `${ctrl.controlId}-${riskId}`;
        if (mappedControls.has(mapKey)) continue;
        mappedControls.add(mapKey);

        try {
          await useTrustStore.getState().addRiskMapping(ctrl.controlId, {
            riskId: String(riskId),
            riskName: item.risk || "",
            severity: item.severity || "",
            source: "AI",
            addedBy: userData?.email,
            addedByUserId: userData?.["cognito:username"],
          });
        } catch (err) {
          console.error(`Risk mapping failed for ${ctrl.controlId}`, err);
        }
      }
    }

    setToastMessage(`✅ "${item.category}" risk recorded. Go to the linked control to set treatment.`);
     logActivity({
            userData,
            orgId:       orgId,
            region:      sessionStorage.getItem('userRegion') || 'AP',
            module:      'Dashboard',
            category:    'Risk',
            action:      'Risk Recorded',
            severity:    'success',
            description: `Risk Recorded for ${item.category}`,});
    setShowToast(true);

  } catch (error) {
    console.error("Error submitting risk:", error);
    const errorMessage =
      error.response?.data?.message ||
      error.response?.data?.error ||
      "Failed to record risk.";
    setToastMessage(`❌ ${errorMessage}`);
    setShowToast(true);
  } 
};

  const startPollingAIStatus = () => {
    setPollingActive(true);
    let elapsedSeconds = 0;
    const maxSeconds = 600;
    const pollingInterval = 1000;

    const interval = setInterval(() => {
      if (elapsedSeconds >= maxSeconds) {
        clearInterval(interval);
        setPollingActive(false);
        console.warn("Polling stopped: timeout after 10 minutes.");
        return;
      }

      const userId = userData?.["cognito:username"];
      

      if (!userId) {
        console.warn("⛔ Skipping status fetch: userId is missing");
        return;
      }

      axios
        .get(
          "https://t1fabjj9ph.execute-api.ap-southeast-2.amazonaws.com/prod/api/status",
          {
            params: { userId },
            headers: { Region: region },
          }
        )
        .then(async (response) => {
        if (response.data.progress !== undefined) {
        setAssessmentProgress(response.data.progress);
       }
       if (response.data.message) {
       setAssessmentProgressMessage(response.data.message);
         }

         if (response.data.status === "COMPLETED") {
  try {
    const parsed = JSON.parse(response.data.aiInsights);
    const newInsights = parsed.insights || [];

    // Sort new insights by severity
    const severityOrder = { Critical: 4, High: 3, Medium: 2, Low: 1 };
    const sortedNew = [...newInsights].sort(
      (a, b) => (severityOrder[b.severity] || 0) - (severityOrder[a.severity] || 0)
    );

    // ✅ MERGE: read existing cached insights, deduplicate by riskId
    const cachedRaw = localStorage.getItem("aiInsights");
    const existing = cachedRaw ? JSON.parse(cachedRaw) : [];
    const existingIds = new Set(existing.map((r) => r.riskId));
    const merged = [
      ...existing,
      ...sortedNew.filter((r) => !existingIds.has(r.riskId)),
    ].sort(
      (a, b) => (severityOrder[b.severity] || 0) - (severityOrder[a.severity] || 0)
    );

    // ✅ Update state with MERGED set — no override
    setAiInsights(merged);
    setAiIdentifiedRisks(merged);
    checkAndNotifyCriticalRisks(merged, true);

    const mergedFullResponse = { ...parsed, insights: merged };
    setFullAIResponse(mergedFullResponse);
    setInsightStatus("Completed");
    setPollingActive(false);
    clearInterval(interval);

    // ✅ Persist MERGED set to localStorage
    localStorage.setItem("aiInsights", JSON.stringify(merged));
    localStorage.setItem("fullAIResponse", JSON.stringify(mergedFullResponse));
    localStorage.setItem("aiInsightsTimestamp", Date.now().toString());

    // ✅ Save MERGED set to DynamoDB
    await saveUserAssessment(mergedFullResponse);

    // ✅ Only auto-link the NEW risks (avoid duplicate control mappings)
    await autoLinkRisksToControls(sortedNew);

    // ✅ Mark manual risk queue entries as processed
    setProcessedManualRisks(sortedNew.map((r) => r.riskId));

  } catch (error) {
    console.error("Failed to parse AI insight JSON", error);
  }
}
        })
        .catch((err) => {
          console.error(
            "❌ Error fetching insights:",
            err.response?.data || err.message
          );
        });

      elapsedSeconds += 1;
    }, pollingInterval);
  };

  // const fetchAcceptedRisks = async () => {
  //   try {
  //     const res = await axios.get(
  //       "https://v7qjnmmi5b.execute-api.eu-west-1.amazonaws.com/prod/api/accepted-risk/list",
  //       {
  //         params: { userId, region: getUserRegion() },
  //       }
  //     );
  //     setAcceptedRisks(res.data);
  //   } catch (error) {
  //     console.error("Error fetching accepted risks:", error);
  //   }
  // };

useEffect(() => {
  if (userId) {
    fetchAndCacheAIInsights(); // This will check cache first, then fetch if needed
  }
}, [userId]);


  const handleFileUpload = (e) => {
    setSelectedFiles(e.target.files);
  };

const handleFileSubmit = async () => {
    if (selectedFiles.length === 0) {
      setToastMessage("Please select files to upload.");
      setShowToast(true);
      // await fetchUploadedFiles();
      return;
    }
 
    const formData = new FormData();
    for (let i = 0; i < selectedFiles.length; i++) {
      formData.append("file", selectedFiles[i]);
    }
 
    formData.append("email", userData?.email);
    formData.append("userId", userData?.["cognito:username"]);
    formData.append("region", getUserRegion());
    formData.append("documentType", "ExternalDocument");
 
    try {
      await axios.post(
        "https://ygjftpwt0k.execute-api.ap-southeast-2.amazonaws.com/prod/api/external-pdf/upload",
        formData,
        {
          headers: {
           
            Region: getUserRegion(),
          },
        }
      );
      setToastMessage("PDF(s) uploaded successfully!");
       logActivity({
            userData,
            orgId:       orgId,
            region:      sessionStorage.getItem('userRegion') || 'AP',
            module:      'Dashboard',
            category:    'Access Reports',
            action:      'Pdf Recorded',
            severity:    'success',
            description: `Pdf uploaded`,});
     
      setShowToast(true);
 
      setSelectedFiles([]); // Clear selectedFiles state
      if (fileInputRef.current) {
        // Reset the actual input field
        fileInputRef.current.value = null;
      }
        await fetchUploadedFiles();
    } catch (err) {
      console.error("Upload error:", err);
      setToastMessage("Upload failed.");
      setShowToast(true);
    }
  };

  const getFutureDate = (daysToAdd) => {
    const date = new Date();
    date.setDate(date.getDate() + daysToAdd);
    return date.toISOString().slice(0, 16); // returns 'YYYY-MM-DDTHH:mm'
  };
  useEffect(() => {
    const storedInsights = localStorage.getItem("uploadedRisks");
    if (storedInsights) {
      setAiInsights(JSON.parse(storedInsights));
    }
  }, []);

  useEffect(() => {
    if (
      location.pathname === "/" &&
      activeTab === "risk" &&
      localStorage.getItem("seenSubmitPopup") !== "true"
    ) {
      setShowSubmitPopup(true);
      localStorage.setItem("seenSubmitPopup", "true");
    }
  }, [location, activeTab]);

  useEffect(() => {
    if (!userId) return;
    const fetchData = async () => {
      try {
        const sections = [
          "AWSIAM",
          "AWSDetection",
          "AWSInfrastructureProtection",
          "AWSDataProtection",
          "AWSIRAutomation",
          "GenAI",
          "EntraAzureIAM",
          "EntraAzureDetection",
          "AzureInfraProtection",
          "AzureDataProtection",
          "EntraAzureAutomation",
          "GoogleCloudIAM",
          "GoogleCloudDetection",
          "GoogleInfraProtection",
          "GoogleDataProtection",
          "GoogleIRAutomation",
          "M365IAMMFA",
          "UserAdministration",
          "IntuneEnrollment",
          "GroupPolicies",
          "HybridConnect",
          "CloudMigration",
          "Sentinel",
          "BitLockerEncryption",
          "FirewallManagement",
          "WindowsUserPatching",
          "SSOEntApp",
          "BlockchainSecurity",
          "Organizational",
          "People",
          "Physical",
          "Technological",
          "DataAndRiskMgmt",
          "LegalCompliance",
          "PrivacyEngineering",
          "PrivacyFramework",
          "CISSecurity",
          "DevSecOps",
          "OperationalResilience",
          "DORASecurity",
          "CRASecurity",
          "NIS2Security",
          "CSCRFSecurity",
          "NCSBIrelandSecurity",
          "CSRBSecurity",
          "GovAssureSecurity",
          "CIRCIASecurity",
          "AIExecutiveOrdersSecurity",
          "PS213",
          "ICOEncryptionParticipation",
          "CSRBIncidentReporting",
          "PECRAlignment",
          "PostQuantumCryptography",
          "RegulatorEngagement",
          "MSPDataCentreFocus",
          "TelecomSecurityAct",
          "PCIDSSCompliance",
          "NCSCCAF",
          "PSNCompliance",
          "OTIoTSecurity",
          "NetworkSecurity",
          "PrivateCloudHypervisor",
          "Cisco",
          "Juniper",
          "Fortinet",
          "PaloAlto",
          "Checkpoint",
          "HIPAA",
          "RED",
          "EUAIActCompliance",
          "BS7858Security",
          "SOC2",
          "NISTSP80053",
          "NISTSP80063IAM",
          "NISTPrivacyFramework",
          "NISTSP800161",
          "NCSCSupplyChainGuidelines",
          "CERTINSupplyChainGuidelines",
          "PDPL",
          "CyberEssentials2014",
          "SOXCompliance",
          "MITRE",
           "OWASP",
          "COBIT",
          "OracleCloudIAM",
          "OracleCloudDetection",
          "OracleCloudInfrastructureProtection",
          "OracleCloudDataProtection",
          "OracleCloudIncidentResponseAndAutomation",

        ];

        await Promise.all(
          sections.map((section) => fetchResponsesForSection(userId, section))
        );
      } catch (error) {
        console.error("Error fetching section responses:", error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [userId, fetchResponsesForSection]);

const btnPrimary = {
  padding: "7px 16px", borderRadius: "8px", fontSize: "12px", fontWeight: 600,
   cursor: "pointer", border: "none",backgroundColor:"#024A82",color:"#FFFFF",
   fontFamily:"'Inter', sans-serif",
   display: "inline-flex",
  alignItems: "center", gap: "5px",
};

  const handleDownloadReport = (report) => {
    const { timestamp, score, recommendedModules = [], insights = [] } = report;

    // Prepare data for Excel
    const metaSheet = [
      ["Timestamp", new Date(timestamp).toLocaleString()],
      ["Score", score],
      ["Recommended Modules", recommendedModules.join(", ") || "None"],
    ];

    const insightsSheet = insights.map((insight) => ({
      "Risk ID": insight.riskId,
      Category: insight.category,
      Severity: insight.severity,
      "Risk Description": insight.risk,
      "Asset Affected": insight.assetAffected,
      "Threat Source": insight.threatSource,
      "Risk Owner": insight.riskOwner,
      "Avoidable Loss": insight.avoidableLoss ?? "",
      "Review Date": insight.reviewDate,
      Recommendation: insight.recommendation,
    }));

    // Create workbook
    const wb = XLSX.utils.book_new();

    const metaWs = XLSX.utils.aoa_to_sheet(metaSheet);
    XLSX.utils.book_append_sheet(wb, metaWs, "Summary");

    const insightsWs = XLSX.utils.json_to_sheet(insightsSheet);
    XLSX.utils.book_append_sheet(wb, insightsWs, "Insights");

    // Generate Excel file
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([wbout], { type: "application/octet-stream" });

    // Save file
    const filename = `Assessment_Report_${new Date(
      timestamp
    ).toISOString()}.xlsx`;
    saveAs(blob, filename);
  };

  const fetchAssessmentHistory = async () => {
    if (!userId || !hasMoreHistory) return; // stop if nothing to fetch
    setLoadingHistory(true);
    try {
      const res = await axios.get(
        `https://qmxmhlyxkh.execute-api.ap-southeast-2.amazonaws.com/prod/api/user-assessment-history`,
        {
          headers: { Region: getUserRegion() },
          params: {
            userId,
            limit: 3, // or 10 — adjust based on UI
            lastEvaluatedKey: lastEvaluatedKey || undefined,
          },
        }
      );

      const newItems = res.data.items || [];
      setAssessmentHistory((prev) => [...prev, ...newItems]);

      if (res.data.lastEvaluatedKey) {
        setLastEvaluatedKey(res.data.lastEvaluatedKey); // Set next key
        setHasMoreHistory(true);
      } else {
        setHasMoreHistory(false); // No more data
      }
    } catch (error) {
      console.error("Failed to fetch assessment history", error);
      setAssessmentHistory([]);
    } finally {
      setLoadingHistory(false);
    }
  };

  useEffect(() => {
    fetchAssessmentHistory();
  }, [userId]);

  const saveUserAssessment = async (aiData) => { 
    try {
      const payload = {
        email: userData?.email,
        userId: userId,
        score: scaledScore,
        previousScore: previousScore, 
        recommendedModules: aiData?.recommendedModules  || [],
        insights: aiData?.insights || [],
      };
      await axios.post(
       "https://kl319lk9yc.execute-api.ap-southeast-2.amazonaws.com/prod/api/save-assessment",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Region: getUserRegion(),
          },
        }
      );
      

       await saveCachedAIInsights(aiData);
      savePreviousScore(scaledScore);
       const sortedInsights = (aiData?.insights || []).sort((a, b) => {
      const severityOrder = { Critical: 4, High: 3, Medium: 2, Low: 1 };
      return (severityOrder[b.severity] || 0) - (severityOrder[a.severity] || 0);
    });
    
    const fullResponse = {
      insights: sortedInsights,
      recommendedModules: aiData?.recommendedModules || [],
      score: scaledScore,
      timestamp: new Date().toISOString()
    };
    
    // Update cache with fresh data
    localStorage.setItem("aiInsights", JSON.stringify(sortedInsights));
    localStorage.setItem("fullAIResponse", JSON.stringify(fullResponse));
    localStorage.setItem("aiInsightsTimestamp", Date.now().toString());
    


    } catch (error) {
      console.error("❌ Error saving assessment data:", error);
    }
  };

  const getUserRegion = () => sessionStorage.getItem("userRegion") || "GB";

  const fetchAIInsights = async () => {
    setInsightsLoading(true);
    try {
      const token = localStorage.getItem("susanGeneratedToken");
      const connectedVendors = [];
      if (localStorage.getItem("M365") === "connected")
        connectedVendors.push("M365");
      if (localStorage.getItem("Intruder") === "connected")
        connectedVendors.push("Intruder");
      if (localStorage.getItem("Datadog") === "connected")
        connectedVendors.push("Datadog");
      if (localStorage.getItem("Sentinel") === "connected")
        connectedVendors.push("Sentinel");

      const vendor =
        connectedVendors.length > 0 ? connectedVendors : ["Unknown"];

    
      const userId= userData?.["cognito:username"];
      const orgId = profile?.orgId;
      const susanGenieData = {};
    const sectionsWithResponses = Object.keys(responses);
    
    sectionsWithResponses.forEach(section => {
      const key = `susanGenie_${section}_${userId}`;
      const savedData = localStorage.getItem(key);
      
      if (savedData) {
        try {
          const parsedData = JSON.parse(savedData);
          if (parsedData.enabled) {
            susanGenieData[section] = parsedData;
          }
        } catch (error) {
          console.warn(`Failed to parse SUSAN Genie data for ${section}:`, error);
        }
      }
    });
  
    const userCSCRFData = cscrfChecklistData?.[userId];
   
    
    const cscrfChecklistPayload = userCSCRFData && Object.keys(userCSCRFData).length > 0
      ? {
          completedItems: Object.entries(userCSCRFData)
            .filter(([key, data]) => key !== "lastUpdated" && data && data.isCompleted)
            .reduce((acc, [id, data]) => {
              acc[id] = data;
              return acc;
            }, {}),
          totalCompleted: Object.values(userCSCRFData).filter(
            (item) => item && typeof item === 'object' && item.isCompleted && item.id
          ).length,
          timestamp: new Date().toISOString(),
        }
      : null;
    
   
      const payload = buildAnsweredOnlyPayload({ userId, overviewData, responses, formData, token, vendor, susanGenieData,  cscrfChecklistData: cscrfChecklistPayload, orgId,  manualRisks: manualRisks ?? []  });
if (assetData && assetData.length > 0) {
    const assetSummary = assetData
        .slice(0, 50)
        .map(asset => {
            const value = Number(asset.assetValue) || 0;
            const ef    = Number(asset.exposureFactor) / 100 || 0.5;
            const aro   = Number(asset.annualizedRateOfOccurrence) || 0.2;
            const sle   = Math.round(value * ef * 100) / 100;
            const ale   = Math.round(sle * aro * 100) / 100;
            return {
                assetName:         asset.assetName,
                assetCategory:     asset.assetCategory,
                assetSerialNumber: asset.assetSerialNumber,
                owner:             asset.owner,
                location:          asset.location,
                assetValue:        value,
                exposureFactor:    asset.exposureFactor,
                sle,
                ale,
            };
        });
    payload.assetInventory = assetSummary;
    console.log("✅ Added", assetSummary.length, "assets to AI payload");
}

      console.log("📤 Sending AI insights payload:", payload);
       console.log("📤 Payload cscrfChecklistData:", payload.cscrfChecklistData);
     
      const res = await axios.post(      
        "https://whe92we7fi.execute-api.eu-west-1.amazonaws.com/prod/assessment/submit-async",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Region: getUserRegion(),
            UserId: userId, 
          },
        }
        
        
      );
        
     if (res.data?.message && res.data.message.includes("No data provided")) {
      console.log("⚠️ No data provided response detected!"); // Debug log
      setToastMessage(`⚠️ ${res.data.message}`);
      setShowToast(true);
      
      // Don't return immediately - let the state update propagate
      setInsightsLoading(false);
      return {}; // Return empty object but after setting loading to false
    }

    // Check for any other informational message without insights
    if (res.data?.message && !res.data?.insights) {
      console.log("ℹ️ Info message detected:", res.data.message);
      setToastMessage(`ℹ️ ${res.data.message}`);
      setShowToast(true);
      setInsightsLoading(false);
      return {};
    }
      if (res.status === 200) {
        let extractedJson;
        if (typeof res.data === "string") {
          const match = res.data.match(/```json\n([\s\S]*?)\n```/);
          console.log("⚙️ Raw res.data:", res.data);

          extractedJson =
            match && match[1]
              ? JSON.parse(match[1])
              : JSON.parse(
                  res.data.slice(
                    res.data.indexOf("{"),
                    res.data.lastIndexOf("}") + 1
                  )
                );
          console.log("🧠 Extracted insights:", extractedJson.insights);
        } else {
          extractedJson = res.data;
        }

        console.log(
          "📚 Extracted JSON object:",
          JSON.stringify(extractedJson, null, 2)
        );
        setFullAIResponse(extractedJson);
        // setAiInsights(extractedJson.insights || []);
        const sortedInsights = (extractedJson.insights || []).sort((a, b) => {
          const severityOrder = { Critical: 4, High: 3, Medium: 2, Low: 1 };
          return severityOrder[b.severity] - severityOrder[a.severity];
        });
      //  setAiInsights(sortedInsights);
    // ✅ MERGE with existing cached insights
const cachedRaw = localStorage.getItem("aiInsights");
const existing = cachedRaw ? JSON.parse(cachedRaw) : [];
const existingIds = new Set(existing.map((r) => r.riskId));
const merged = [
  ...existing,
  ...sortedInsights.filter((r) => !existingIds.has(r.riskId)),
].sort((a, b) => {
  const severityOrder = { Critical: 4, High: 3, Medium: 2, Low: 1 };
  return (severityOrder[b.severity] || 0) - (severityOrder[a.severity] || 0);
});

setAiInsights(merged);
setAiIdentifiedRisks(merged);

// ✅ Only auto-link NEW risks to avoid duplicate control mappings
await autoLinkRisksToControls(sortedInsights);
return { ...extractedJson, insights: merged };

     await autoLinkRisksToControls(sortedInsights);
        return extractedJson; // Return the full response
      } else {
        console.warn("⚠️ Non-200 response from AI:", res.status);
        return {};
      }
    } catch (error) {
      console.error("Failed to fetch AI insights:", error);
      return {};
    } finally {
      setInsightsLoading(false);
    }
  };

  const handleFinalSubmit = async () => {
   setIsSubmitting(true);
    setAssessmentProgress(0);
setAssessmentProgressMessage("Submitting your assessment...");
    try {
      // 🔥 FIX: Move userId declaration to the TOP
    const userId = userData?.["cognito:username"];
   
    
    // COLLECT SUSAN GENIE DATA from localStorage
    const susanGenieData = {};
    const sectionsWithResponses = Object.keys(responses);
    console.log("🔍 Debug - sectionsWithResponses:", sectionsWithResponses); // Debug 2

      const userCSCRFData = cscrfChecklistData[userId];
    const cscrfChecklistPayload = userCSCRFData ? {
      completedItems: Object.entries(userCSCRFData)
        .filter(([key, data]) => key !== 'lastUpdated' && data.isCompleted)
        .reduce((acc, [id, data]) => {
          acc[id] = data;
          return acc;
        }, {}),
      totalCompleted: Object.values(userCSCRFData).filter(
        item => item.isCompleted && item.id
      ).length,
      timestamp: new Date().toISOString()
    } : null;
    
    
  

    console.log("🔥 Final susanGenieData:", susanGenieData); // Debug 9
    console.log("🔥 susanGenieData keys:", Object.keys(susanGenieData)); // Debug 10

    // ENHANCED PAYLOAD with SUSAN Genie data
    const payload = {
      ...buildAnsweredOnlyPayload({ userId, overviewData, responses, formData,  orgId: profile?.orgId }),
      susanGenieData ,  cscrfChecklistPayload, // ✅ Add SUSAN Genie data here
        manualRisks: manualRisks ?? [],
    };
    
    console.log("📤 Final payload:", payload); // Debug 11
    console.log("📤 Payload susanGenieData:", payload.susanGenieData); // Debug 12
      const res = await axios.post(
        "https://as4kn3phg7.execute-api.eu-west-1.amazonaws.com/prod/assessment/submit",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Region: getUserRegion(),
          },
        }
      );
       hasLoadedOnce.current = false;
      console.log("📥 Received submit response:", res.data);
      if (res.status === 200) {
        setToastMessage("Data submitted successfully!");
          logActivity({
            userData,
            orgId:       orgId,
            region:      sessionStorage.getItem('userRegion') || 'AP',
            module:      'Dashboard',
            category:    'Risk',
            action:      'Data Submitted',
            severity:    'success',
            description: `Data Submitted`,});
        setShowToast(true);
        const aiStart = await fetchAIInsights();
        console.log("✅ AI job submission acknowledged:", aiStart);
        setPollingActive(true);

        startPollingAIStatus();
        console.log("Poling is started");
      }
    } catch (error) {
      console.error("❌ Submission failed:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  // Section-wise scores and percentages
  const sectionScores = useMemo(() => {
    const scores = {};
    const percentages = {};

    Object.keys(scoreData).forEach((section) => {
      const sectionResponses = Object.values(scoreData[section]);

      // Filter out "NA" responses
      const validResponses = sectionResponses.filter(
        (item) => item.value !== "NA"
      );

      const totalQuestions = validResponses.length;
      const totalScore = validResponses.reduce(
        (acc, item) => acc + Number(item.value),
        0
      );

      const percentage =
        totalQuestions > 0
          ? Math.round((totalScore / totalQuestions) * 100)
          : 0;

      scores[section] = totalScore;
      percentages[section] = percentage;
    });

    return { scores, percentages };
  }, [scoreData]);

  const barChartData = useMemo(() => {
    // Default categories with display names
    const defaultCategories = [
      { key: "AWS", displayName: "AWS" },
      { key: "AzureEntra", displayName: "Azure Entra" },
      { key: "Google Cloud", displayName: "Google Cloud" },
      { key: "M365", displayName: "M365" },
    ];

    // Check if there are any non-zero scores
    const hasResponses = Object.values(sectionScores.scores).some(
      (score) => score > 0
    );

    if (!hasResponses) {
      // If no responses, return default categories with zero scores
      return defaultCategories.map((category) => ({
        name: category.displayName,
        score: 0,
        percentage: 0,
      }));
    }

    // If responses exist, filter out sections with zero scores and percentages
    return Object.keys(sectionScores.scores)
      .filter(
        (section) =>
          sectionScores.scores[section] > 0 ||
          sectionScores.percentages[section] > 0
      )
      .map((section) => ({
        name: section, // Actual section name
        score: sectionScores.scores[section],
        percentage: sectionScores.percentages[section],
      }));
  }, [sectionScores]);

  // Combine scores from all modules correctly
  const combinedScores = useMemo(() => {
    // Flatten the nested structure and extract the `value` fields
    return Object.values(scoreData)
      .flat() // Flatten the nested structure
      .map((entry) => Object.values(entry)) // Extract the nested objects
      .flat(); // Flatten again to create a single array
  }, [scoreData]);

  const validScoreData = useMemo(
    () =>
      combinedScores
        .map((item) => {
          if (item.value === "NA") return null; // Ignore "NA" or handle as needed
          const parsedValue = Number(item.value);
          return !isNaN(parsedValue) ? parsedValue : null; // Convert to number or null
        })
        .filter((value) => value !== null), // Remove nulls
    [combinedScores]
  );

  const totalScore = useMemo(
    () => validScoreData.reduce((acc, curr) => acc + curr, 0),
    [validScoreData]
  );

  // const scaledScore = useMemo(
  //   () =>
  //     validScoreData.length > 0
  //       ? Math.round((totalScore / validScoreData.length) * 100)
  //       : 0,
  //   [totalScore, validScoreData]
  // );

  const calculateScoreTrend = (currentScore, prevScore) => {
  if (!prevScore || prevScore === 0) return null;
  
  const change = currentScore - prevScore;
  const percentChange = Math.round((change / prevScore) * 100);
  
  let trend = 'stable';
  if (change > 0) trend = 'up';
  else if (change < 0) trend = 'down';
  
  return {
    change: Math.abs(change),
    percentChange: Math.abs(percentChange),
    trend,
    isImprovement: change > 0
  };
};

  const scaledScore = useMemo(() => {
  const currentScore = validScoreData.length > 0 
    ? Math.round((totalScore / validScoreData.length) * 100) 
    : 0;
  
  // Get previous score from localStorage
  const savedPreviousScore = localStorage.getItem(`previousScore_${userId}`);
  const prevScore = savedPreviousScore ? parseInt(savedPreviousScore) : null;
  
  // Calculate trend if we have both current and previous scores
  if (prevScore !== null && prevScore !== currentScore) {
    const trendData = calculateScoreTrend(currentScore, prevScore);
    setScoreChange(trendData);
    setScoreTrend(trendData?.trend);
  } else {
    // Reset trend data if no previous score or scores are the same
    setScoreChange(null);
    setScoreTrend(null);
  }
  
  setPreviousScore(prevScore);
  
  return currentScore;
}, [totalScore, validScoreData, userId]);

const savePreviousScore = (score) => {
  localStorage.setItem(`previousScore_${userId}`, score.toString());
};

// Call this in your handleFinalSubmit or when AI insights are completed
useEffect(() => {
  if (scaledScore > 0 && insightStatus === 'Completed') {
    // Only save as previous score when assessment is truly complete
    savePreviousScore(scaledScore);
  }
}, [scaledScore, insightStatus, userId]);

  

  const recommendedModules = useMemo(() => {
     console.log("🔍 Full AI Response:", fullAIResponse);
  console.log("🔍 Recommended modules from AI:", fullAIResponse.recommendedModules);
    const allowedModules = [
      "AWS Cloud Security",
      "Azure Entra Cloud Security",
      "Google Cloud Security",
      "M365",
      "DevSecOps",
      "Operational Resilience",
      "Application & Database Security",
      "Blockchain Security",
      "Wireless Security",
      "ISO 27001 Compliance",
      "Privacy/Data Protection Compliance",
      "CIS Security",
       "API Integration",           // ✅ Added
      "Telecom Security Act",      // ✅ Added
      "OT/IoT Security",
      "Network Infrastructure"
    ];

    // Extract recommended_modules directly from backend response
    const aiModuleList = fullAIResponse.recommendedModules || [];

    // Filter to include only allowed modules
    const filteredAiModules = aiModuleList.filter((mod) =>
      allowedModules.includes(mod)
    );

    // Merge with fallback defaults, deduplicate
    if (filteredAiModules.length === 0) {
      return ["Privacy", "ISO 27001 Compliance", "API Integration"];
    }
    return [...new Set(filteredAiModules)];
  }, [fullAIResponse]);

  const handleSubmitReminder = async () => {
    if (!reminderDate || !selectedReminderItem) {
      setToastMessage("Please select a reminder date.");
      setShowToast(true);
      return;
    }

    try {
      await axios.post(
        "https://r3yokl6lm6.execute-api.eu-west-1.amazonaws.com/prod/reminder",
        {
          userId: userData?.["cognito:username"],
          userEmail: userData?.email,
          category: selectedReminderItem.category,
          description: selectedReminderItem.description,
          reminderDate,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Region: getUserRegion(),
          },
        }
      );

      setToastMessage("Reminder saved successfully!");
      setShowToast(true);
      setShowReminderModal(false);
    } catch (error) {
      console.error("Error saving reminder:", error);
      setToastMessage("Failed to save reminder.");
      setShowToast(true);
    }
  };



const checkAndNotifyCriticalRisks = (risks, isFromAI = false) => {
  const currentCriticalRisks = risks.filter(risk => risk.severity === "Critical");
  const currentCriticalRiskIds = currentCriticalRisks.map(r => r.riskId);
  
  // Only skip on page load (localStorage restoration), not AI completion
  if (!hasLoadedOnce.current && !isFromAI) {
    hasLoadedOnce.current = true;
    setCriticalRiskCount(currentCriticalRisks.length);
    setPreviousCriticalRiskIds(currentCriticalRiskIds);
    return;
  }
  
  // For AI completion, always check for notifications
  if (isFromAI || hasLoadedOnce.current) {
    hasLoadedOnce.current = true;
    
    if (currentCriticalRisks.length > 0 && (emailNotificationEnabled || pushNotificationEnabled)) {
      const lastNotification = lastNotificationSent.timestamp || 0;
      const timeSinceLast = Date.now() - lastNotification;
      const minimumInterval = 5 * 60 * 1000;

      if (timeSinceLast > minimumInterval) {
       sendCriticalRiskNotification(
       currentCriticalRisks, userData, region
);

        setPreviousCriticalRiskIds(currentCriticalRiskIds);
      }
    }
  }
  
  setCriticalRiskCount(currentCriticalRisks.length);
};



//phone number logic

// Phone number validation
const validatePhoneNumber = (phone) => {
  const phoneRegex = /^\+[1-9]\d{8,14}$/; // E.164 format
  return phoneRegex.test(phone);
};

// Get API base URL based on region
// Single API base URL - no region switching needed
// Different base URLs for different services
const getPhoneManagementAPI = () => {
  return 'https://k3ovrf176c.execute-api.eu-west-1.amazonaws.com/prod';
};

const getUpdatePhoneAPI = () => {
  return 'https://lrfzeooc9f.execute-api.eu-west-1.amazonaws.com/prod';
};




const handlePrivacyModuleClick = (path) => {
    sessionStorage.setItem(
        "navKeepOpen",
        JSON.stringify({ openSection: "Privacy/DataProtectioncompliance" })
    );
    navigate(path);
};
const generateReportData = () => {
  const reportData = {
    timestamp: new Date().toISOString(),
    score: scaledScore,
    userData: {
      name: userData?.name,
      email: userData?.email,
      userId: userId
    },
    insights: displayedRisks,
    recommendedModules: recommendedModules,
    assessmentSummary: {
      totalRisks: displayedRisks.length,
      criticalRisks: displayedRisks.filter(risk => risk.severity === "Critical").length,
      highRisks: displayedRisks.filter(risk => risk.severity === "High").length,
      mediumRisks: displayedRisks.filter(risk => risk.severity === "Medium").length,
      lowRisks: displayedRisks.filter(risk => risk.severity === "Low").length
    }
  };
  return reportData;
};

// Function to download PDF report
const handleDownloadPDF = async () => {
   try {
  setIsDownloadingPDF(true);
  const doc = new jsPDF({ unit: "pt", format: "a4", orientation: "portrait" });
  const pageWidth = 595;
  const pageHeight = 842;
  
  // Brand colors from your guidelines
  const brandColors = {
    primary: "#6BCEEF",      // Light Blue
    secondary: "#035EA5",    // Dark Blue
    accent: "#FFFF00",       // Yellow
    textDark: "#2C3E50",     // Dark text
    textLight: "#5A6C7D",    // Light text
    background: "#F8F9FA",   // Light background
    white: "#FFFFFF",
    lightGray: "#E9ECEF"
  };

  // Header Section
  doc.setFillColor(brandColors.secondary);
  doc.rect(0, 0, pageWidth, 100, "F");
  
  // Logo (adjust path as needed)
  try {
    doc.addImage(logoImg, 'PNG', 30, 20, 60, 60);
  } catch (error) {
    // Fallback logo
    doc.setFillColor(brandColors.accent);
    doc.circle(60, 50, 25, "F");
    doc.setTextColor(brandColors.secondary);
    doc.setFontSize(20);
    doc.setFont("helvetica", "bold");
    doc.text("S", 55, 58);
  }

  // Main Title
  doc.setTextColor(brandColors.white);
  doc.setFontSize(32);
  doc.setFont("helvetica", "bold");
  doc.text("SUSAN Security Report", 120, 45);
  
  // Subtitle
  doc.setFontSize(14);
  doc.setFont("helvetica", "normal");
  doc.text(`Generated on ${new Date().toLocaleDateString()}`, 120, 70);

  // Executive Summary Section
  let yPos = 130;
  
  // Summary Box
  doc.setFillColor("#F8F9FA");
  doc.setDrawColor(brandColors.primary);
  doc.setLineWidth(2);
  doc.roundedRect(30, yPos, 535, 120, 8, 8, "FD");
  
  // Security Score Circle
  const scoreX = 480;
  const scoreY = yPos + 60;
  
  // Score background circle
  doc.setFillColor(brandColors.primary);
  doc.circle(scoreX, scoreY, 40, "F");
  
  // Inner score circle
  doc.setFillColor(brandColors.white);
  doc.circle(scoreX, scoreY, 32, "F");
  
  // Score text
  doc.setTextColor(brandColors.secondary);
  doc.setFontSize(24);
  doc.setFont("helvetica", "bold");
  const scoreStr = `${scaledScore}%`;
  const scoreWidth = doc.getTextWidth(scoreStr);
  doc.text(scoreStr, scoreX - (scoreWidth / 2), scoreY + 5);

  // Summary Text
  doc.setTextColor(brandColors.textDark);
  doc.setFontSize(18);
  doc.setFont("helvetica", "bold");
  doc.text("Executive Summary", 50, yPos + 30);
  
  doc.setFontSize(12);
  doc.setFont("helvetica", "normal");
  doc.text(`Total Risks Identified: ${displayedRisks.length}`, 50, yPos + 75);
  doc.text(`User: ${userData?.name || 'N/A'}`, 50, yPos + 95);
  doc.text(`Email: ${userData?.email || 'N/A'}`, 50, yPos + 115);

  yPos += 150;

  // Risk Summary Cards
  doc.setTextColor(brandColors.secondary);
  doc.setFontSize(16);
  doc.setFont("helvetica", "bold");
  doc.text("Risk Overview", 30, yPos);
  
  yPos += 30;
  
  const riskCounts = {
    Critical: displayedRisks.filter(r => r.severity === "Critical").length,
    High: displayedRisks.filter(r => r.severity === "High").length,
    Medium: displayedRisks.filter(r => r.severity === "Medium").length,
    Low: displayedRisks.filter(r => r.severity === "Low").length
  };

  const severityColors = {
    Critical: "#DC3545",
    High: "#FD7E14", 
    Medium: "#FFC107",
    Low: "#28A745"
  };

  let cardX = 30;
  Object.entries(riskCounts).forEach(([severity, count]) => {
    if (count > 0) {
      // Card background
      doc.setFillColor(severityColors[severity]);
      doc.roundedRect(cardX, yPos, 120, 60, 8, 8, "F");
      
      // Card text
      doc.setTextColor(brandColors.white);
      doc.setFontSize(28);
      doc.setFont("helvetica", "bold");
      const countStr = count.toString();
      const countWidth = doc.getTextWidth(countStr);
      doc.text(countStr, cardX + 60 - (countWidth / 2), yPos + 30);
      
      doc.setFontSize(12);
      doc.setFont("helvetica", "normal");
      const severityWidth = doc.getTextWidth(severity);
      doc.text(severity, cardX + 60 - (severityWidth / 2), yPos + 45);
      const risksWidth = doc.getTextWidth("Risks");
      doc.text("Risks", cardX + 60 - (risksWidth / 2), yPos + 58);
      
      cardX += 135;
    }
  });

  yPos += 90;

  // Recommended Modules Section
  if (recommendedModules && recommendedModules.length > 0) {
    doc.setTextColor(brandColors.secondary);
    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    doc.text("Recommended Security Modules", 30, yPos);
    
    yPos += 25;
    
    // Module box
    doc.setFillColor("#F8F9FA");
    doc.setDrawColor(brandColors.lightGray);
    doc.setLineWidth(1);
    const moduleBoxHeight = Math.max(60, recommendedModules.length * 18 + 20);
    doc.roundedRect(30, yPos, 535, moduleBoxHeight, 5, 5, "FD");
    
    yPos += 25;
    doc.setTextColor(brandColors.textDark);
    doc.setFontSize(11);
    doc.setFont("helvetica", "normal");
    
    recommendedModules.forEach((module, index) => {
      // Bullet point
      doc.setFillColor(brandColors.accent);
      doc.circle(45, yPos - 3, 3, "F");
      
      // Module text
      doc.text(module, 55, yPos);
      yPos += 18;
    });
    
    yPos += 30;
  }

  // New page for detailed risks if needed
  if (yPos > 700) {
    doc.addPage();
    yPos = 50;
  }

  // Detailed Risk Analysis Table
  doc.setTextColor(brandColors.secondary);
  doc.setFontSize(16);
  doc.setFont("helvetica", "bold");
  doc.text("Detailed Risk Analysis", 30, yPos);
  
  yPos += 20;

  // Enhanced table with better styling
 autoTable(doc, {
  startY: yPos,
  head: [[
    "ID", "Category", "Severity", "Risk Description", 
    "Asset Affected", "Threat Source", "Owner", "Date", "Recommendations"
  ]],
  body: displayedRisks.map(r => [
    r.riskId ?? "-",
    r.category ?? "-", 
    r.severity ?? "-",
     r.risk ?? r.description ?? "-",
    r.assetAffected ?? "-",
    r.threatSource ?? "-",
    r.riskOwner ?? "-",
    r.reviewDate ? new Date(r.reviewDate).toLocaleDateString() : "-",
    r.recommendation ?? "-" 
  ]),
  // Add these key properties to fix the overflow
  margin: { left: 30, right: 30 },                    // Proper margins
  tableWidth: 535,                                     // Fixed table width
  
  theme: "grid",
  styles: {
    fontSize: 7,                                       // Smaller font
    cellPadding: 4,                                    // Reduced padding
    textColor: brandColors.textDark,
    lineColor: "#DEE2E6",
    lineWidth: 0.5,
    font: "helvetica",
    overflow: 'linebreak',
    minCellHeight: 20                                // Enable text wrapping
  },
  headStyles: {
    fillColor: brandColors.secondary,
    textColor: brandColors.white,
    fontStyle: "bold",
    fontSize: 8,                                       // Smaller header font
    halign: "center"
  },
  alternateRowStyles: {
    fillColor: "#F8F9FA"
  },
  columnStyles: {
    0: { cellWidth: 25, halign: "center" },            // ID - smaller
    1: { cellWidth: 45 },                              // Category - smaller  
    2: { cellWidth: 35, halign: "center" },            // Severity - smaller
    3: { cellWidth: 110, cellPadding: 4, overflow: 'linebreak' },      // Risk Description - with wrapping
    4: { 
      cellWidth: 60, 
      overflow: 'linebreak',
      cellPadding: 4 
    },      // Asset Affected
   5: { 
      cellWidth: 55, 
      overflow: 'linebreak',
      cellPadding: 4 
    },       // Threat Source
    6: { cellWidth: 45 },                              // Owner - smaller
    7: { cellWidth: 35, halign: "center" },            // Date - smaller
     8: { 
      cellWidth: 120, 
      overflow: 'linebreak',                      // Force line breaking
      cellPadding: 4
    }      // Recommendations - with wrapping
  },

   // Add row height configuration
  willDrawCell: function (data) {
    // Make rows taller for text wrapping
    if (data.cell.section === 'body') {
      data.cell.styles.minCellHeight = 25;       // Ensure minimum height for wrapping
    }
  },


  didDrawCell: function (data) {
    // Color-code severity column
    if (data.column.index === 2 && data.cell.section === 'body') {
      const severity = data.cell.text[0];
      if (severityColors[severity]) {
        doc.setFillColor(severityColors[severity]);
        doc.roundedRect(data.cell.x + 1, data.cell.y + 1, data.cell.width - 2, data.cell.height - 2, 3, 3, "F");
        doc.setTextColor(brandColors.white);
        doc.setFont("helvetica", "bold");
        const textWidth = doc.getTextWidth(severity);
        doc.text(severity, data.cell.x + (data.cell.width - textWidth) / 2, data.cell.y + data.cell.height / 2 + 2);
      }
    }
  }
});

  // Footer on all pages
  const pageCount = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    
    // Footer background
    doc.setFillColor(brandColors.secondary);
    doc.rect(0, pageHeight - 40, pageWidth, 40, "F");
    
    // Footer content
    doc.setTextColor(brandColors.white);
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.text("SUSAN - Secure Your Digital Assets", 30, pageHeight - 25);
    
    doc.setFont("helvetica", "normal");
    doc.text(`Page ${i} of ${pageCount}`, pageWidth - 100, pageHeight - 25);
    
    // Generation info
    doc.setFontSize(8);
    doc.text(`Generated: ${new Date().toLocaleString()}`, 30, pageHeight - 10);
  }

  // Save the PDF
  doc.save(`SUSAN_Security_Report_${Date.now()}.pdf`);
} catch (error) {
    console.error("Error generating PDF:", error);
    setToastMessage("❌ Failed to generate PDF");
    setShowToast(true);
  } finally {
    setIsDownloadingPDF(false);
  }
};



// Function to email PDF report
const handleEmailPDF = () => {
  // Show email input modal instead of directly sending
  setEmailAddress(userData?.email || '');
  setShowEmailModal(true);
};

const sendEmailReport = async () => {
  if (!emailAddress || !emailAddress.includes('@')) {
    setToastMessage('Please enter a valid email address');
    setShowToast(true);
    return;
  }

  setIsEmailingPDF(true);
  try {
    // 1. Start with landscape orientation for the entire document
    const doc = new jsPDF({ 
      unit: "pt", 
      format: "a4", 
      orientation: "landscape",  // Start with landscape
      compress: true
    });
    
    const pageWidth = 842;   // Landscape width
    const pageHeight = 595;  // Landscape height
    
    // Brand colors
    const brandColors = {
      primary: "#6BCEEF",
      secondary: "#035EA5", 
      accent: "#FFFF00",
      textDark: "#2C3E50",
      textLight: "#5A6C7D",
      background: "#F8F9FA",
      white: "#FFFFFF",
      lightGray: "#E9ECEF"
    };

    // Header across full landscape width
    doc.setFillColor(brandColors.secondary);
    doc.rect(0, 0, pageWidth, 70, "F");
    
    // Logo
    try {
      doc.addImage(logoImg, 'PNG', 30, 20, 40, 40);
    } catch (error) {
      doc.setFillColor(brandColors.accent);
      doc.circle(50, 40, 18, "F");
      doc.setTextColor(brandColors.secondary);
      doc.setFontSize(14);
      doc.setFont("helvetica", "bold");
      doc.text("S", 46, 46);
    }

    // Title
    doc.setTextColor(brandColors.white);
    doc.setFontSize(24);
    doc.setFont("helvetica", "bold");
    doc.text("SUSAN Security Assessment Report", 100, 35);
    
    doc.setFontSize(11);
    doc.setFont("helvetica", "normal");
    doc.text(`Generated: ${new Date().toLocaleDateString()} | User: ${userData?.name || 'N/A'}`, 100, 55);

    // Compact summary in landscape format - LEFT SIDE
    let yPos = 90;
    
    // Summary box (left half of page)
    doc.setFillColor("#F8F9FA");
    doc.setDrawColor(brandColors.primary);
    doc.setLineWidth(1);
    doc.rect(30, yPos, 380, 120, "FD");
    
    // Executive Summary header
    doc.setTextColor(brandColors.secondary);
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    doc.text("Executive Summary", 40, yPos + 20);
    
    // Security Score
    doc.setFontSize(16);
    doc.text("Security Score", 40, yPos + 45);
    
    // Score circle
    const scoreColor = scaledScore < 30 ? "#DC3545" : scaledScore < 70 ? "#FFC107" : "#28A745";
    doc.setFillColor(scoreColor);
    doc.circle(330, yPos + 50, 25, "F");
    doc.setTextColor(brandColors.white);
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    doc.text(`${scaledScore}%`, 320, yPos + 55);
    
    // Summary details
    doc.setTextColor(brandColors.textDark);
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text(`Total Risks: ${displayedRisks.length}`, 40, yPos + 85);
    doc.text(`Assessment Date: ${new Date().toLocaleDateString()}`, 40, yPos + 100);

    // Risk Overview Cards - RIGHT SIDE
    const riskCounts = {
      Critical: displayedRisks.filter(r => r.severity === "Critical").length,
      High: displayedRisks.filter(r => r.severity === "High").length,
      Medium: displayedRisks.filter(r => r.severity === "Medium").length,
      Low: displayedRisks.filter(r => r.severity === "Low").length
    };

    const severityColors = {
      Critical: "#DC3545",
      High: "#FD7E14",
      Medium: "#FFC107", 
      Low: "#28A745"
    };

    // Risk cards (right half of page)
    doc.setTextColor(brandColors.secondary);
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    doc.text("Risk Distribution", 450, yPos + 20);

    let cardX = 450;
    let cardY = yPos + 35;
    let cardCount = 0;

    Object.entries(riskCounts).forEach(([severity, count]) => {
      if (count > 0) {
        // Card background
        doc.setFillColor(severityColors[severity]);
        doc.roundedRect(cardX, cardY, 80, 35, 3, 3, "F");
        
        // Card text
        doc.setTextColor(brandColors.white);
        doc.setFontSize(14);
        doc.setFont("helvetica", "bold");
        doc.text(count.toString(), cardX + 15, cardY + 18);
        
        doc.setFontSize(8);
        doc.setFont("helvetica", "normal");
        doc.text(severity, cardX + 30, cardY + 18);
        doc.text("Risks", cardX + 30, cardY + 28);
        
        cardCount++;
        if (cardCount % 2 === 0) {
          cardX = 450;
          cardY += 45;
        } else {
          cardX += 90;
        }
      }
    });

    // Recommended Modules (if space allows)
    if (recommendedModules && recommendedModules.length > 0 && yPos + 150 < pageHeight - 100) {
      doc.setTextColor(brandColors.secondary);
      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.text("Recommended Modules:", 450, yPos + 110);
      
      doc.setTextColor(brandColors.textDark);
      doc.setFontSize(8);
      doc.setFont("helvetica", "normal");
      
      recommendedModules.slice(0, 3).forEach((module, index) => {
        doc.text(`• ${module}`, 450, yPos + 125 + (index * 12));
      });
    }

    // Risk Table - SAME PAGE, BOTTOM SECTION
    yPos = 230;  // Start table higher up on the same page

    doc.setTextColor(brandColors.secondary);
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    doc.text("Detailed Risk Analysis", 30, yPos);
    
    yPos += 20;

    // Full width table with all columns
    autoTable(doc, {
      startY: yPos,
      head: [[
        "ID", "Category", "Severity", "Risk Description", 
        "Asset Affected", "Threat Source", "Owner", "Date", "Recommendations"
      ]],
      body: displayedRisks.map(r => [
        r.riskId ?? "-",
        r.category ?? "-",
        r.severity ?? "-",
        r.risk ?? r.description ?? "-",
        r.assetAffected ?? "-",
        r.threatSource ?? "-",
        r.riskOwner ?? "-",
        r.reviewDate ? new Date(r.reviewDate).toLocaleDateString() : "-",
        r.recommendation ?? "-"
      ]),
      
      margin: { left: 30, right: 30 },
      tableWidth: 782,  // Full landscape width minus margins
      
      theme: "grid",
      styles: {
        fontSize: 7,
        cellPadding: 2,
        textColor: brandColors.textDark,
        lineColor: "#CCCCCC",
        lineWidth: 0.3,
        overflow: 'linebreak',
        minCellHeight: 18
      },
      headStyles: {
        fillColor: brandColors.secondary,
        textColor: brandColors.white,
        fontStyle: "bold",
        fontSize: 8,
        halign: "center",
        minCellHeight: 22
      },
      alternateRowStyles: {
        fillColor: "#F8F9FA"
      },
      columnStyles: {
        0: { cellWidth: 30, halign: "center" },     // ID
        1: { cellWidth: 70, overflow: 'linebreak' }, // Category
        2: { cellWidth: 45, halign: "center" },     // Severity
        3: { cellWidth: 140, overflow: 'linebreak' }, // Risk Description
        4: { cellWidth: 80, overflow: 'linebreak' }, // Asset Affected
        5: { cellWidth: 80, overflow: 'linebreak' }, // Threat Source
        6: { cellWidth: 60 },                       // Owner
        7: { cellWidth: 40, halign: "center" },     // Date
        8: { cellWidth: 140, overflow: 'linebreak' } // Recommendations
      },
      
      willDrawCell: function (data) {
        if (data.cell.section === 'body') {
          data.cell.styles.minCellHeight = 20;
        }
      },
      
      didDrawCell: function (data) {
        if (data.column.index === 2 && data.cell.section === 'body') {
          const severity = data.cell.text[0];
          if (severityColors[severity]) {
            doc.setFillColor(severityColors[severity]);
            doc.roundedRect(data.cell.x + 1, data.cell.y + 1, data.cell.width - 2, data.cell.height - 2, 2, 2, "F");
            doc.setTextColor(brandColors.white);
            doc.setFont("helvetica", "bold");
            const textWidth = doc.getTextWidth(severity);
            doc.text(severity, data.cell.x + (data.cell.width - textWidth) / 2, data.cell.y + data.cell.height / 2 + 2);
          }
        }
      }
    });

    // Footer
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setTextColor(brandColors.textLight);
      doc.setFontSize(8);
      doc.text(`SUSAN Security Report | Page ${i} of ${pageCount} | ${new Date().toLocaleDateString()}`, 30, pageHeight - 15);
    }

    // Rest of your code (PDF generation and sending)...
    const pdfBase64 = doc.output('datauristring').split(',')[1];
    
    const estimatedSizeMB = (pdfBase64.length * 0.75) / (1024 * 1024);
    console.log(`📄 PDF Size: ${estimatedSizeMB.toFixed(2)} MB`);
    
    if (estimatedSizeMB > 8) {
      throw new Error(`PDF too large (${estimatedSizeMB.toFixed(1)}MB). Please reduce data or try downloading instead.`);
    }
    
    const response = await axios.post(
      "https://a2h6glizy1.execute-api.ap-southeast-2.amazonaws.com/prod/api/email-pdf-report",
      {
        emailTo: emailAddress,
        userName: userData?.name || 'User',
        pdfData: pdfBase64,
        subject: `SUSAN Security Report - ${new Date().toLocaleDateString()}`
      },
      {
        headers: {
          "Content-Type": "application/json",
          "Region": getUserRegion(),
        },
        timeout: 30000
      }
    );

    if (response.data.success) {
      setToastMessage(`✅ PDF report emailed to ${emailAddress} (${estimatedSizeMB.toFixed(1)}MB)`);
      setShowToast(true);
      setShowEmailModal(false);
    } else {
      throw new Error(response.data.error || 'Email sending failed');
    }
  } catch (error) {
    console.error("Error emailing PDF report:", error);
    if (error.code === 'ERR_BAD_REQUEST' && error.response?.status === 413) {
      setToastMessage("❌ PDF too large for email. Please try downloading instead.");
    } else {
      setToastMessage("❌ Failed to email PDF report");
    }
    setShowToast(true);
  } finally {
    setIsEmailingPDF(false);
  }
};



const handleRealtimeToggle = async (enabled) => {
  if (!userId) {
    setToastMessage("User not found. Please log in again.");
    setShowToast(true);
    return;
  }
  
  setToggleLoading(true);
  try {
    const response = await axios.post(
       "https://a24ub0je11.execute-api.ap-southeast-2.amazonaws.com/prod/api/realtime/toggle",  // Update with your actual domain
      
      null,
      {
        params: {
          userId: userId,
          region: getUserRegion(),
          enabled: enabled,
          enabledBy: "user"
        },
        headers: {
          "Content-Type": "application/json"
        }
      }
    );

    if (response.status === 200) {
      setRealtimeEnabled(enabled);
      setRealtimeStatus(enabled);
      localStorage.setItem(`realtimeEnabled_${userId}`, JSON.stringify(enabled));
      
      setToastMessage(response.data.message || 
        `Real-time processing ${enabled ? 'enabled' : 'disabled'} successfully!`);
      setShowToast(true);
      
      if (!enabled) {
        setLiveInsights([]);
      } else {
        fetchLiveInsights();
      }
    }
  } catch (error) {
    console.error("Failed to toggle real-time processing:", error);
    setToastMessage(
      error.response?.data?.message || 
      "Failed to update real-time settings. Please try again."
    );
    setShowToast(true);
  } finally {
    setToggleLoading(false);
  }
};


const fetchLiveInsights = async () => {
  if (!userId || !realtimeEnabled) return;
  
  setLiveInsightsLoading(true); // Start loading
  try {
    const response = await axios.get(
       `https://lobfj6x3ag.execute-api.ap-southeast-2.amazonaws.com/prod/api/realtime/insights/${userId}`,
      {
        params: {
          region: getUserRegion(),
          limit: 50 // Get latest 50 insights
        }
      }
    );

    if (response.status === 200 && response.data) {
      console.log("📥 Fetched live insights:", response.data);
      setLiveInsights(response.data);
      setLastInsightUpdate(new Date());
    }
  } catch (error) {
    console.error("Failed to fetch live insights:", error);
  } finally {
    setLiveInsightsLoading(false); // End loading
  }
};




useEffect(() => {
  if (!userId) return;
  
  const checkRealtimeStatus = async () => {
    try {
      const response = await axios.get(
        `https://34q3j4iy4c.execute-api.ap-southeast-2.amazonaws.com/prod/api/realtime/status/${userId}`, // Update with your actual domain
        {
          params: {
            region: getUserRegion()
          }
        }
      );

      if (response.status === 200) {
        const isEnabled = response.data.realtimeEnabled || false;
        setRealtimeEnabled(isEnabled);
        setRealtimeStatus(isEnabled);
        localStorage.setItem(`realtimeEnabled_${userId}`, JSON.stringify(isEnabled));
        
        // If enabled, fetch live insights
        if (isEnabled) {
          fetchLiveInsights();
        }
      }
    } catch (error) {
      console.error("Failed to check real-time status:", error);
      // Use localStorage fallback
      const saved = localStorage.getItem(`realtimeEnabled_${userId}`);
      if (saved) {
        setRealtimeEnabled(JSON.parse(saved));
      }
    }
  };

  checkRealtimeStatus();
}, [userId]);

useEffect(() => {
  if (!realtimeEnabled || !userId) return;

  // Auto-refresh insights every 10 seconds when real-time is enabled
  const interval = setInterval(() => {
    fetchLiveInsights();
  }, 10000); // 10 seconds

  return () => clearInterval(interval);
}, [realtimeEnabled, userId]);



const handleChooseFileClick = () => {
  fileInputRef.current?.click();
};


// In your fetchAssessmentHistory or saveUserAssessment functions
const fetchPreviousScore = async () => {
  if (!userId) return;
  try {
    const response = await axios.get(
      `https://nv84ane4v9.execute-api.ap-southeast-2.amazonaws.com/prod/api/user-previous-score`,
      
      {
        params: { userId },
        headers: { 'Region': getUserRegion() }
      }
    );
    
    if (response.data.previousScore) {
      setPreviousScore(response.data.previousScore);
      localStorage.setItem(`previousScore_${userId}`, response.data.previousScore.toString());
    }
  } catch (error) {
    console.error('Error fetching previous score:', error);
  }
};


// Call this when component mounts
useEffect(() => {
  if (userId) {
    fetchPreviousScore();
  }
}, [userId]);


  return (
    <>
    <div className="securitymodelcss">
      <Row className="g-0">
         <Col
    xs={12}
    className={`bg-transparent sidebar-container ${isSidebarCollapsed ? "collapsed" : "hello"}`}
    style={{
      width: isSidebarCollapsed ? "90px" : "317px",
      transition: "width 0.3s ease",
    }}
  >
          <Menubar
            isCollapsed={isSidebarCollapsed}
           onToggle={handleSidebarToggle}
          />


        </Col>
        
        <ToastContainer
          position="top-end"
          className="p-3"
          style={{ marginTop: "60px" }}
        >
          <Toast
            show={showToast}
            onClose={() => setShowToast(false)}
            delay={3000}
            autohide
          >
            <Toast.Body
              style={{ backgroundColor: "#d4edda", color: "#155724" }}
            >
              {toastMessage}
            </Toast.Body>
          </Toast>
        </ToastContainer>
        <Col
    className="pt-0 px-0  ps-0 section-container"
    style={{
      width: `calc(100% - ${isSidebarCollapsed ? "90px" : "317px"})`,
      transition: "width 0.3s ease",
    }}
  >
            <NavigationBar
      userData={userData}
      isSidebarCollapsed={isSidebarCollapsed}
    />
 <Col className="overflow-auto p-3">
 
          <Tabs
            activeKey={activeTab}
            onSelect={(k) => {
              setActiveTab(k);
              localStorage.setItem("activeSecurityTab", k);
            }}
            id="security-tabs"
            className="mb-3 security-tabs-margin"
           
            
          >
          
            <Tab eventKey="risk" title="Central Risk Dashboard">
              <Row className="mb-4">
               

                  
  <Col xs={12}>
    <div className="d-flex flex-wrap gap-3 dashboard-widgets-container">
      
      {/* Speedometer Widget - Fixed Width */}
      <div className="dashboard-widget flex-fill rounded-3 bg-white  p-4" style={{ minWidth: '320px', maxWidth: '400px' }}>
        {/* Widget Header */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h6 className="text-muted fw-semibold mb-1 text-uppercase" style={{ fontSize: '0.75rem', letterSpacing: '0.5px' }}>
              Security Score
            </h6>
            <div className="d-flex align-items-baseline">
              <h2 className="fw-bold mb-0 text-dark">
                {scaledScore}%
              </h2>
              {scoreChange && (
                <span 
                  className={`ms-2 badge rounded-pill ${scoreChange.isImprovement ? 'bg-success' : 'bg-danger'}`}
                  style={{ fontSize: '0.65rem' }}
                >
                  {scoreChange.isImprovement ? '↗' : '↘'} {scoreChange.percentChange}%
                </span>
              )}
            </div>
          </div>
        </div>

      
        <div className="d-flex justify-content-center mb-2">
        <SmoothSpeedometer value={scaledScore} />
 
        </div>

      
      </div> 

      {/* Risk Distribution Pie Chart Widget - Fixed Width */}
      <div className="dashboard-widget flex-fill rounded-3 bg-white  p-4" style={{ minWidth: '320px', maxWidth: '400px' }}>
        {/* Widget Header */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h6 className="text-muted fw-semibold mb-1 text-uppercase" style={{ fontSize: '0.75rem', letterSpacing: '0.5px' }}>
              Risk Distribution
            </h6>
            <h2 className="fw-bold mb-0 text-dark">
              {displayedRisks.length} Risks
            </h2>
          </div>
        </div>

        {/* Enhanced Pie Chart */}
        {displayedRisks.length > 0 ? (
          <>
            <div style={{ height: '210px', marginLeft: '-30px' , overflow:'visible'}}>
              <ResponsiveContainer width="100%" height="100%" >
                <PieChart>
                  <Pie
                    data={[
                      {
                        name: 'Critical',
                        value: displayedRisks.filter(risk => risk.severity === 'Critical').length,
                        color: '#dc3545',
                        percentage: Math.round((displayedRisks.filter(risk => risk.severity === 'Critical').length / displayedRisks.length) * 100)
                      },
                      {
                        name: 'High',
                        value: displayedRisks.filter(risk => risk.severity === 'High').length,
                        color: '#fd7e14',
                        percentage: Math.round((displayedRisks.filter(risk => risk.severity === 'High').length / displayedRisks.length) * 100)
                      },
                      {
                        name: 'Medium',
                        value: displayedRisks.filter(risk => risk.severity === 'Medium').length,
                        color: '#ffc107',
                        percentage: Math.round((displayedRisks.filter(risk => risk.severity === 'Medium').length / displayedRisks.length) * 100)
                      },
                      {
                        name: 'Low',
                        value: displayedRisks.filter(risk => risk.severity === 'Low').length,
                        color: '#28a745',
                        percentage: Math.round((displayedRisks.filter(risk => risk.severity === 'Low').length / displayedRisks.length) * 100)
                      }
                    ].filter(item => item.value > 0)}
                    cx="50%"         
                    cy="50%"
                    innerRadius={35}
                    outerRadius={65}
                    paddingAngle={0}
                    dataKey="value"
                    label={({name, percentage}) => `${name}: ${percentage}%`}
                    labelLine={false}
                  >                                   {[
                      {
                        name: 'Critical',
                        value: displayedRisks.filter(risk => risk.severity === 'Critical').length,
                        color: '#dc3545'
                      },
                      {
                        name: 'High',
                        value: displayedRisks.filter(risk => risk.severity === 'High').length,
                        color: '#fd7e14'
                      },
                      {
                        name: 'Medium',
                        value: displayedRisks.filter(risk => risk.severity === 'Medium').length,
                        color: '#ffc107'
                      },
                      {
                        name: 'Low',
                        value: displayedRisks.filter(risk => risk.severity === 'Low').length,
                        color: '#28a745'
                      }
                    ].filter(item => item.value > 0).map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={entry.color} stroke={entry.color} strokeWidth={2} />
                    ))}
                  </Pie>
                  <Tooltip 
                    formatter={(value, name) => [value, `${name} Risks`]}
                    contentStyle={{
                      backgroundColor: '#fff',
                      border: '1px solid #e9ecef',
                      borderRadius: '8px',
                      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                      fontSize: '0.85rem'
                    }}
                  />
                </PieChart>
              </ResponsiveContainer>
            </div>

            {/* Risk Summary Grid */}
            <div className="row g-2 mt-2">
              {[
                { name: 'Critical', color: '#dc3545', count: displayedRisks.filter(r => r.severity === 'Critical').length },
                { name: 'High', color: '#fd7e14', count: displayedRisks.filter(r => r.severity === 'High').length },
                { name: 'Medium', color: '#ffc107', count: displayedRisks.filter(r => r.severity === 'Medium').length },
                { name: 'Low', color: '#28a745', count: displayedRisks.filter(r => r.severity === 'Low').length }
              ].filter(item => item.count > 0).map((item, index) => (
                <div key={index} className="col-6">
                  <div 
                    className="d-flex align-items-center justify-content-between p-2 rounded-2"
                    style={{ backgroundColor: `${item.color}15`, border: `1px solid ${item.color}30` }}
                  >
                    <div className="d-flex align-items-center">
                      <div 
                        className="rounded-circle me-2"
                        style={{ 
                          width: '10px', 
                          height: '10px', 
                          backgroundColor: item.color 
                        }}
                      ></div>
                      <small className="text-dark fw-medium" style={{ fontSize: '0.75rem' }}>
                        {item.name}
                      </small>
                    </div>
                    <span 
                      className="badge rounded-pill"
                      style={{ backgroundColor: item.color, fontSize: '0.7rem' }}
                    >
                      {item.count}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </>
        ) : (
          <div className="d-flex flex-column align-items-center justify-content-center" style={{ height: '180px' }}>
           <div className="alignment">
            <p className="text-muted mb-1 fw-medium">No risks identified</p>
            <small className="text-muted">Complete assessment to view distribution</small>
            </div>
          </div>
        )}
      </div>

      {/* Avoidable Loss Widget - Fixed Width */}
      <div className="dashboard-widget-avoidable flex-fill  bg-white p-4" style={{ minWidth: '320px', maxWidth: '400px' }}>
        <AvoidableLossWidget
          assets={assetData}
          currency={assetCurrency}
          title="Financial Impact"
          defaultMitigation={70}
        />
      </div>
    </div>
  </Col>
  </Row>

                   <div className="d-flex justify-content-end mt-3 gap-2">
                   
             
             {/* Add this button near other dashboard controls - around line where Download/Email Report buttons are */}
   <Button
  variant=""
  onClick={() => {
    setShowShareModal(true);
    fetchSharedUsers(); // Load shared users when modal opens
  }}
  style={btnPrimary}
  className="me-2 text-white"
>
  Share Dashboard
</Button>
 
           
           {/* Download/Email Report Button */}
           <Button
            variant=""
    onClick={() => setShowDownloadModal(true)}
    disabled={displayedRisks.length === 0}
    className="me-2 text-white"
    style={btnPrimary}
  >
     Download/Email Report
  </Button>
               <Button
  variant="success"
  onClick={handleFinalSubmit}
  disabled={isSubmitting || pollingActive}
  className="Submitbtn"
>
  {isSubmitting ? (
    <>
      <Spinner animation="border" size="sm" className="me-2" />
      Submitting your data...
    </>
  ) : pollingActive ? (
    <>
      <Spinner animation="border" size="sm" className="me-2" />
      AI is processing... {assessmentProgress}%
    </>
  ) : (
    <span className="Submi">Commit & Recalculate Risk Score</span>
  )}
</Button>
  </div>

    <div className="mb-2 d-flex align-items-center justify-content-between">
  <h5 className="fw-bold Risk-Register mb-0 "> Risk Register</h5>
  
 
</div>

                 <Row className="mb-3 align-items-center">
  {/* Left Section: Upload + Download */}
<Col md={7} className="d-flex flex-column flex-md-row align-items-start align-items-md-center gap-3">
<div className="realtime-toggle-container d-flex align-items-center ailabel">
  <div className="form-check form-switch">
    <input
      className="form-check-input aitoggle1"
      type="checkbox"
      id="realtimeToggle"
      checked={realtimeEnabled}
      onChange={(e) => handleRealtimeToggle(e.target.checked)}
      disabled={toggleLoading}
    />
    <label className="form-check-label small" htmlFor="realtimeToggle">
      {toggleLoading ? (
        <>
          <Spinner animation="border" size="sm" className="me-1" />
          Updating...
        </>
      ) : (
        <>
          {realtimeEnabled ? (
            <>
              🟢 Live API Processing Active
              {liveInsightsLoading && (
                <Spinner 
                  animation="border" 
                  size="sm" 
                  className="ms-2" 
                  style={{ width: '12px', height: '12px' }}
                />
              )}
            </>
          ) : '⚫ API Polling'}
        </>
      )}
    </label>
  </div>
</div>

 
 <Dropdown as={ButtonGroup}>
  <Dropdown.Toggle 
    variant="outline-success" 
    className="ImportExportDropdown text-white"
  >
    Import/Export
  </Dropdown.Toggle>
  <Dropdown.Menu>
    <Dropdown.Item onClick={downloadSampleTemplate}>
       Download Template
    </Dropdown.Item>
    <Dropdown.Divider />
    <Dropdown.Item onClick={handleChooseFileClick}>
       Choose File
    </Dropdown.Item>
  </Dropdown.Menu>
</Dropdown>

{/* Hidden file input */}
<Form.Control
  ref={fileInputRef}
  className="upload-input d-none"
  type="file"
  accept=".xlsx, .xls"
  onChange={handleRiskFileUpload}
/>
  </Col>

  {/* Right Section: Filter + Sort */}
  <Col md={5} className="d-flex flex-column flex-md-row justify-content-md-end gap-3 mt-3 mt-md-0">
    <Form.Group>
      <Form.Label className="mb-1 small text-muted">Filter by Source</Form.Label>
      
      <Form.Select
  size="sm"
  value={realtimeEnabled ? "live" : riskFilter} // Auto-set to live when enabled
  onChange={(e) => {
    if (!realtimeEnabled) {
      setRiskFilter(e.target.value);
    }
  }}
  disabled={realtimeEnabled} // Disable filter when live mode is on
  style={{ minWidth: "160px" }}
>
  {realtimeEnabled ? (
    <option value="live">Live AI Insights</option>
  ) : (
    <>
      <option value="all">All Risks</option>
      <option value="ai">Identified Risks</option>
      <option value="uploaded">Uploaded Risks</option>
    </>
  )}
</Form.Select>

    </Form.Group>

    <Form.Group>
      <Form.Label className="mb-1 small text-muted">Sort by Severity</Form.Label>
      <Form.Select
  size="sm"
  onChange={(e) => {
    const order = e.target.value;
    const severityOrder = { Critical: 4, High: 3, Medium: 2, Low: 1 };
    const sortFn = (a, b) =>
      order === "high-low"
        ? severityOrder[b.severity] - severityOrder[a.severity]
        : severityOrder[a.severity] - severityOrder[b.severity];

    if (riskFilter === "uploaded") {
      setUploadedRisks([...uploadedRisks].sort(sortFn));
    } else if (riskFilter === "ai") {
      setAiIdentifiedRisks([...aiIdentifiedRisks].sort(sortFn)); // ✅ Fixed: was setAiInsights
    } else {
      setUploadedRisks([...uploadedRisks].sort(sortFn));
      setAiIdentifiedRisks([...aiIdentifiedRisks].sort(sortFn)); // ✅ Fixed: was setAiInsights
    }
  }}
  style={{ minWidth: "160px" }}
>
  <option value="">Select</option>
  <option value="high-low">High to Low</option>
  <option value="low-high">Low to High</option>
</Form.Select>

    </Form.Group>
  </Col>
</Row>
              {/* 🔥 New Recommended Modules Section */}

              <Row className="mb-4">
                <Col>
                  <div className="dashboard-card p-3 shadow-sm rounded bg-white ">
                    <h6 className="text-primary">Identified Open Risks</h6>
       {cacheFetching ? (
        <div className="d-flex align-items-center justify-content-center py-4">
          <Spinner animation="border" variant="primary" size="sm" className="me-2" />
          <span className="text-muted">Loading cached insights...</span>
        </div>
      ) : pollingActive ? (
  <div className="p-3" style={{ maxWidth: '500px' }}>
    <div className="d-flex align-items-center gap-2 mb-2">
      <Spinner animation="border" variant="primary" size="sm" />
      <span className="text-primary fw-medium" style={{ fontSize: '14px' }}>
        {assessmentProgressMessage || "Preparing your assessment..."}
      </span>
      <span className="ms-auto text-muted" style={{ fontSize: '13px' }}>
        {assessmentProgress}%
      </span>
    </div>
    <div style={{
      height: '8px',
      background: '#e9ecef',
      borderRadius: '99px',
      overflow: 'hidden',
      marginBottom: '8px'
    }}>
      <div style={{
        height: '100%',
        width: `${assessmentProgress}%`,
        background: '#035EA5',
        borderRadius: '99px',
        transition: 'width 0.8s ease'
      }} />
    </div>
    <div className="d-flex justify-content-between" style={{ fontSize: '11px', color: '#adb5bd' }}>
      <span style={{ color: assessmentProgress >= 10 ? '#035EA5' : '#adb5bd', fontWeight: assessmentProgress >= 10 ? '600' : '400' }}>Data collected</span>
      <span style={{ color: assessmentProgress >= 25 ? '#035EA5' : '#adb5bd', fontWeight: assessmentProgress >= 25 ? '600' : '400' }}>Controls loaded</span>
      <span style={{ color: assessmentProgress >= 35 ? '#035EA5' : '#adb5bd', fontWeight: assessmentProgress >= 35 ? '600' : '400' }}>AI analysing</span>
      <span style={{ color: assessmentProgress >= 70 ? '#035EA5' : '#adb5bd', fontWeight: assessmentProgress >= 70 ? '600' : '400' }}>Scoring</span>
      <span style={{ color: assessmentProgress >= 100 ? '#035EA5' : '#adb5bd', fontWeight: assessmentProgress >= 100 ? '600' : '400' }}>Complete</span>
    </div>
  </div>
                    ) : displayedRisks.length > 0 ? (
                      <>
                            <div className="table-responsive-sm ai-risk-table-wrapper" ref={tableScrollRef}>
                                <ResizableTable tableId="risk-insights"  className="table table-sm table-hover align-middle text-center ai-risk-table ">
                                  <thead className="table-light">
                                    <tr>
                                      <th className="text-start">ID</th>
                                      <th className="text-start">Category</th>
                                      <th className="text-start">Severity</th>
                                      <th className="text-start">
                                        Risk Description
                                      </th>
                                       <th className="text-start">Linked Controls</th>
                                        <th className="text-start">Inherent Risk</th>
                                         <th className="text-start">Residual Risk</th>
                                      <th className="text-start">
                                        Asset Affected
                                      </th>
                                      <th className="text-start">
                                        Threat Source
                                      </th>
                                      <th className="text-start">Owner</th>
                                      <th className="text-start">Date</th>
                                      <th className="text-start">
                                        Recommendations
                                      </th>
                                     <th className="text-start" style={{minWidth:"320px"}}>Actions</th>
                                      <th className="text-start">
                                        Next Review
                                      </th>
                                    </tr>
                                  </thead>
                                 <tbody>
  {displayedRisks.map((item, index) => (
   <tr
  key={index}
  id={`risk-row-${item.riskId}`}
  style={{
    cursor: 'pointer',
    backgroundColor: highlightedRiskId === item.riskId ? '#E6F0F9' : 'transparent',
    transition: 'background-color 0.5s ease',
    outline: highlightedRiskId === item.riskId ? '2px solid #035EA5' : 'none',
  }}
  onClick={() => { setSelectedRisk(item); setShowRiskPanel(true); }}
>
      <td>{item.riskId}</td>
      <td>{item.category}</td>
      <td style={{ textAlign: 'center' }}>
  <span className="badge rounded-pill" style={{
    backgroundColor: item.severity === 'Critical' ? '#dc3545'
      : item.severity === 'High' ? '#fd7e14'
      : item.severity === 'Medium' ? '#ffc107' : '#198754',
    color: item.severity === 'Medium' ? '#000' : '#fff',
    fontSize: '0.75rem',
    padding: '5px 12px',
    minWidth: '70px',
    display: 'inline-block'
  }}>
    {item.severity}
  </span>
</td>
      <td className="text-start">{item.risk}</td>

      {/* Linked Controls */}
      <td onClick={(e) => e.stopPropagation()}>
        {item.linkedControls && item.linkedControls.length > 0 ? (
          <div style={{ fontSize: '12px' }}>
            <span style={{ fontWeight: 'bold', color: '#035EA5' }}>
              {item.linkedControls.length} linked
            </span>
            <br />
            <span className="text-muted">{item.controlCoverage || 0}% cov.</span>
          </div>
        ) : (
          <span className="text-muted" style={{ fontSize: '12px' }}>—</span>
        )}
      </td>

      {/* Inherent Risk */}
      <td>
        {item.inherentRisk ? (
          <span className="badge" style={{
            backgroundColor: item.inherentRisk >= 20 ? '#dc3545'
              : item.inherentRisk >= 15 ? '#fd7e14'
              : item.inherentRisk >= 8 ? '#ffc107' : '#198754',
            color: item.inherentRisk >= 8 && item.inherentRisk < 15 ? '#000' : '#fff',
            fontSize: '11px'
          }}>
            {item.inherentRisk} {item.inherentRisk >= 20 ? 'Critical' : item.inherentRisk >= 15 ? 'High' : item.inherentRisk >= 8 ? 'Medium' : 'Low'}
          </span>
        ) : <span className="text-muted">—</span>}
      </td>

      {/* Residual Risk */}
      <td>
        {item.residualRisk ? (
          <span className="badge" style={{
            backgroundColor: item.residualRisk >= 20 ? '#dc3545'
              : item.residualRisk >= 15 ? '#fd7e14'
              : item.residualRisk >= 8 ? '#ffc107' : '#198754',
            color: item.residualRisk >= 8 && item.residualRisk < 15 ? '#000' : '#fff',
            fontSize: '11px'
          }}>
            {item.residualRisk} {item.residualRiskLevel || ''}
          </span>
        ) : <span className="text-muted">—</span>}
      </td>

      <td>{item.assetAffected}</td>
      <td>{item.threatSource}</td>
      <td>{item.riskOwner}</td>
      <td>{item.reviewDate}</td>
      <td className="text-start">{item.recommendation}</td>

      {/* Actions: View + Manage */}
      <td style={{ textAlign: 'center',minWidth:"320px" }}>
  <div className="d-flex gap-1 justify-content-center">
    <Button variant="primary" size="sm"
      style={{ fontSize: '0.75rem',  borderRadius: '4px' ,...btnPrimary}}
      onClick={() => { setSelectedRisk(item); setShowRiskPanel(true); }}>
      View
    </Button>
    {/* <Button variant="outline-success" size="sm"
      style={{ fontSize: '0.75rem', padding: '4px 10px', borderRadius: '4px' }}
      onClick={() => { setSelectedRisk(item); setRiskAction(''); setShowManageModal(true); }}>
      Manage
    </Button> */}
    <Button variant="" size="sm" className="bg-success text-white"
  style={{ fontSize: '0.75rem', padding: '4px 10px', borderRadius: '4px' }}
  onClick={(e) => {
    e.stopPropagation();
    if (item.linkedControls && item.linkedControls.length > 0) {
      navigate(`/trust/control/${item.linkedControls[0].controlId}`);
    } else {
      setSelectedRisk(item);
      setShowRiskPanel(true);
    }
  }}>
  Manage in Control
</Button>
  </div>
</td>

      {/* Next Review */}
      <td onClick={(e) => e.stopPropagation()}>
        <Button variant="outline-primary" size="sm"
        className="text-white"
        style={btnPrimary}
          onClick={() => { setSelectedReminderItem(item); setReminderDate(''); setShowReminderModal(true); }}>
          SET
        </Button>
      </td>
    </tr>
  ))}
</tbody>

                                </ResizableTable>
                              </div>
                              <div id="sticky-scroll" className="sticky-scrollbar" ref={stickyScrollRef} >
                                <div className="scrollbar-track">
                                </div>
                              </div>
                          </>
                 
                    ) : (
                      <p className="text-muted">
                        Please submit to see identified risks.
                      </p>
                    )}
                    
                  </div>
                </Col>
              </Row>

              <Row className="mb-4">
                <Col>
                  <div className="dashboard-card p-3 shadow-sm rounded bg-white">
                    <h6 className="text-primary">
                      Complete the modules below to enhance accuracy
                    </h6>
                    {pollingActive ? (
  <div className="d-flex align-items-center gap-2 py-2">
    <Spinner animation="border" variant="primary" size="sm" />
    <span className="text-muted" style={{ fontSize: '13px' }}>
      {assessmentProgressMessage || "AI is processing your submission. Please wait..."}
    </span>
    <span className="badge ms-2"
      style={{ background: '#035EA5', color: 'white', fontSize: '11px' }}>
      {assessmentProgress}%
    </span>
  </div>
                    ) : displayedRisks.length > 0 ? (
                      <ul>
                        {recommendedModules.map((mod, idx) => (
                          <li key={idx}>{mod}</li>
                        ))}
                      </ul>
                    ) : (
                      <p className="text-muted">
                        Please submit to see your recommended modules.
                      </p>
                    )}
                  </div>
                </Col>
              </Row>

              <div className="d-flex justify-content-end mt-3">
                <Button
  variant="success"
  onClick={handleFinalSubmit}
  disabled={isSubmitting || pollingActive}
>
  {isSubmitting ? (
    <>
      <Spinner animation="border" size="sm" className="me-2" />
      Submitting your data...
    </>
  ) : pollingActive ? (
    <>
      <Spinner animation="border" size="sm" className="me-2" />
      AI is processing... {assessmentProgress}%
    </>
  ) : (
    "Commit & Recalculate Risk Score"
  )}
</Button>
              </div>
            </Tab>
            <Tab eventKey="global" title="Integrated Risk Insights">
              <GlobalRiskOverview userData={userData} />
            </Tab>
            
           
            <Tab eventKey="sponsor" title="Third-Party Collaboration">
              <Sponsor userData={userData} />
            </Tab>
            <Tab eventKey="internal" title="Internal Invite">
              <InternalInvite userData={userData} />
            </Tab>
            <Tab eventKey="avoidable-loss" title="Estimated Risk Savings">
  <Row className="mb-4">
    <Col>
      <div className="dashboard-card p-4 shadow-sm rounded bg-white">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="text-primary mb-0"> Estimated Risk Savings</h5>
          <Button 
            variant="outline-primary" 
            size="sm"
            onClick={fetchAssetData}
          >
             Refresh Data
          </Button>
        </div>
        
        <AvoidableLossCalculator 
          assets={assetData} 
          currency={assetCurrency}
          userData={userData}
        />
        
        {assetData.length === 0 && (
          <div className="text-center py-4">
            <div className="text-muted mb-3">
            </div>
            <h6 className="text-muted">No Asset Data Available</h6>
            <p className="text-muted mb-3">
              Complete the Asset Inventory module to perform avoidable loss analysis.
            </p>
            <Button 
              variant="primary"
              onClick={() => {
                // Navigate to Asset Inventory - adjust the path as needed
                window.location.href = '/assetinventory';
              }}
            >
              Go to Asset Inventory
            </Button>
          </div>
        )}
      </div>
    </Col>
  </Row>
</Tab>
<Tab eventKey="manual-risk" title="Manual Risk Entry">
  <ManualRisk
    userId={userId}
    profile={profile}
    userData={userData}
    clientIP={clientIP}
    manualRisks={manualRisks}
    setManualRisks={setManualRisks}
    setProcessedManualRisks={setProcessedManualRisks}
    showToastMessage={showToastMessage}
    getUserRegion={getUserRegion}
  />
</Tab>

{/* <Tab eventKey="privacy" title="Privacy/Data Protection"> */}
 
 
 
  <Tab eventKey="reporting" title="Access Reports">
  {/* ── Reports Header ── */}
  <div style={{marginLeft:"15px"}}>
  <div className="p-3 d-flex justify-content-between align-items-start " >
    <div>
      <h5 className=" mb-1" style={{ fontSize: '1.6rem' }}>Access Reports</h5>
      <p className="text-muted mb-0" style={{ fontSize: '0.9rem' }}>
        View assessment history and manage external uploads
      </p>
    </div>
    <Button
      variant="outline-primary"
      size="sm"
      className="d-flex align-items-center gap-2"
      onClick={() => { fetchUploadedFiles(); fetchAssessmentHistory(); }}
      style={{ borderRadius: '8px',...btnPrimary, color:"white",height:"31px" }}
    >
      Refresh
    </Button>
  </div>
 
  {/* ── Upload Section ── */}
  <div style={{
    background: '#f8f9fc', borderRadius: '12px', border: '1px solid #e8eaef',
    padding: '20px 24px', marginBottom: '24px',
    display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '16px'
  }}>
    <div className="d-flex align-items-center gap-3" style={{ flex: 1 }}>
      <label htmlFor="report-file-upload" style={{
        display: 'inline-flex', alignItems: 'center', gap: '8px',
        padding: '8px 18px', border: '1px solid #d0d5dd', borderRadius: '8px',
        background: '#fff', cursor: 'pointer', fontWeight: 500, fontSize: '0.9rem',
        color: '#344054', whiteSpace: 'nowrap'
      }}>
         Choose files
      </label>
      <input id="report-file-upload" type="file" multiple onChange={handleFileUpload}
        style={{ display: 'none' }} ref={fileInputRef} />
      <span className="text-muted" style={{ fontSize: '0.85rem' }}>
        {selectedFiles?.length > 0
          ? Array.from(selectedFiles).map(f => f.name).join(', ')
          : 'No file chosen'}
      </span>
    </div>
    <Button variant="outline-primary" onClick={handleFileSubmit}
    size="sm"
      style={{ borderRadius: '8px', fontWeight: 500, padding: '8px 20px', fontSize: '0.9rem',...btnPrimary,color:"white",height:"31px" }}>
      Upload
    </Button>
  </div>
 
  {/* ── Uploaded Files Table ── */}
  <div style={{
    background: '#fff', borderRadius: '12px', border: '1px solid #e8eaef',
    overflow: 'hidden', marginBottom: '32px'
  }}>
    {loadingFiles ? (
      <div className="d-flex align-items-center justify-content-center p-4">
        <Spinner animation="border" variant="primary" className="me-2" />
        <span>Loading files...</span>
      </div>
    ) : uploadedFiles.length > 0 ? (
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ background: '#f8f9fc', borderBottom: '1px solid #e8eaef' }}>
            {['File Name', 'Type', 'Uploaded Date', 'Actions'].map((h, i) => (
              <th key={i} style={{
                padding: '14px 24px', fontSize: '0.75rem', fontWeight: 600, color: '#667085',
                textTransform: 'uppercase', letterSpacing: '0.05em',
                textAlign: h === 'Actions' ? 'right' : 'left'
              }}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {uploadedFiles.map((file, idx) => {
            const fileName = file.fileName || file.name || 'Unknown';
            const ext = fileName.split('.').pop()?.toUpperCase() || 'FILE';
            return (
              <tr key={idx} style={{ borderBottom: idx < uploadedFiles.length - 1 ? '1px solid #f0f1f3' : 'none' }}>
                <td style={{ padding: '16px 24px' }}>
                  <div className="d-flex align-items-center gap-3">
                    <div style={{
                      width: '36px', height: '36px', borderRadius: '8px', background: '#f0f1f5',
                      display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0
                    }}>📄</div>
                    <span style={{ fontWeight: 500, fontSize: '0.9rem', color: '#1d2939' }}>{fileName}</span>
                  </div>
                </td>
                <td style={{ padding: '16px 24px' }}>
                  <span style={{
                    display: 'inline-block', padding: '3px 10px', borderRadius: '6px',
                    background: '#eef0f6', color: '#4a5578', fontSize: '0.75rem',
                    fontWeight: 600, letterSpacing: '0.02em'
                  }}>{ext}</span>
                </td>
                <td style={{ padding: '16px 24px', fontSize: '0.85rem', color: '#667085' }}>
    {file.uploadedAt
      ? new Date(file.uploadedAt).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })
      : file.createdAt
      ? new Date(file.createdAt).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })
      : file.lastModified
      ? new Date(file.lastModified).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })
      : '—'}
  </td>
                <td style={{ padding: '16px 24px', textAlign: 'right' }}>
                 <div className="d-flex gap-2 justify-content-end">
        <Button
            variant="outline-primary"
            size="sm"
            style={{ borderRadius: 6, fontWeight: 500, fontSize: '0.8rem' }}
            onClick={() => handleDownloadFile(file)}
            disabled={downloadingFile === (file.fileName || file.name)}
        >
            {downloadingFile === (file.fileName || file.name) ? (
                <><Spinner animation="border" size="sm" className="me-1" />Downloading...</>
            ) : 'Download'}
        </Button>
        <Button
            variant="outline-danger"
            size="sm"
            style={{ borderRadius: 6, fontWeight: 500, fontSize: '0.8rem' }}
            onClick={() => confirmDelete(file)}
            disabled={deletingFile === (file.fileName || file.name)}
        >
            {deletingFile === (file.fileName || file.name) ? (
                <><Spinner animation="border" size="sm" className="me-1" />Deleting...</>
            ) : 'Delete'}
        </Button>
    </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    ) : (
      <div className="text-center p-4">
        <p className="text-muted mb-0">No files uploaded yet.</p>
      </div>
    )}
  </div>
 
  {/* ── Assessment History Table ── */}
  <h5 className=" mb-3" style={{ fontSize: '1.3rem' }}>Assessment History</h5>
  <div style={{
    background: '#fff', borderRadius: '12px', border: '1px solid #e8eaef', overflow: 'hidden'
  }}>
    {loadingHistory ? (
      <div className="d-flex align-items-center justify-content-center p-4">
        <Spinner animation="border" variant="primary" className="me-2" />
        <span>Loading history...</span>
      </div>
    ) : assessmentHistory.length > 0 ? (
      <>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#f8f9fc', borderBottom: '1px solid #e8eaef' }}>
              {['Name', 'Date', 'Actions'].map((h, i) => (
                <th key={i} style={{
                  padding: '14px 24px', fontSize: '0.75rem', fontWeight: 600, color: '#667085',
                  textTransform: 'uppercase', letterSpacing: '0.05em',
                  textAlign: h === 'Actions' ? 'right' : 'left'
                }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {assessmentHistory.map((entry, idx) => {
              const date = new Date(entry.timestamp);
              const formattedDate = date.toLocaleDateString('en-US', {
                year: 'numeric', month: 'long', day: 'numeric'
              });
             const assessmentName =
  entry.name ||
  `Assessment Record ${String(idx + 1).padStart(2, '0')}`;
              return (
                <tr key={idx} style={{ borderBottom: idx < assessmentHistory.length - 1 ? '1px solid #f0f1f3' : 'none' }}>
                  <td style={{ padding: '16px 24px', fontWeight: 500, fontSize: '0.9rem', color: '#1d2939' }}>
                    {assessmentName}
                  </td>
                  <td style={{ padding: '16px 24px', fontSize: '0.85rem', color: '#667085' }}>
                    {formattedDate}
                  </td>
                  <td style={{ padding: '16px 24px', textAlign: 'right' }}>
                    <Button variant="outline-primary" size="sm" className="me-2"
                      onClick={() => { setSelectedReport(entry); setShowReportModal(true); }}
                      style={{ borderRadius: '6px', fontWeight: 500, fontSize: '0.8rem',...btnPrimary,color:"white" }}>
                      View Report
                    </Button>
                    <Button variant="outline-success" size="sm"
                    className="bg-success text-white"
                      onClick={() => handleDownloadReport(entry)}
                      style={{ borderRadius: '6px', fontWeight: 500, fontSize: '0.8rem' }}>
                      Download
                    </Button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
 
        {hasMoreHistory && (
          <div style={{ padding: '14px 24px', borderTop: '1px solid #f0f1f3', textAlign: 'center' }}>
            <Button variant="link" onClick={fetchAssessmentHistory} disabled={loadingHistory}
              style={{ color: '#667085', textDecoration: 'none', fontSize: '0.85rem', fontWeight: 500 }}>
              {loadingHistory ? (
                <><Spinner animation="border" size="sm" className="me-2" /> Loading More...</>
              ) : 'View more ›'}
            </Button>
          </div>
        )}
      </>
    ) : (
      <div className="text-center p-4">
        <p className="text-muted mb-0">No assessment history found.</p>
      </div>
    )}
  </div>
  </div>
</Tab>



            

          </Tabs>
         {showReportModal && selectedReport && (
  <div className="susan-assessment-report-overlay">
    <div className="susan-assessment-report-container">
      <div className="susan-assessment-report-content">
        {/* Header Section */}
        <div className="susan-assessment-report-header">
          <div className="susan-report-header-content">
            <div className="susan-report-icon">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
                <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
              </svg>
            </div>
            <div className="susan-report-header-text">
              <h1 className="susan-report-title">Assessment Report Details</h1>
              <p className="susan-report-subtitle">Comprehensive security analysis and recommendations</p>
            </div>
          </div>
          
          <button
            className="susan-report-close-btn"
            onClick={() => setShowReportModal(false)}
            aria-label="Close Report"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
            </svg>
          </button>
        </div>

        {/* Content Section */}
        <div className="susan-assessment-report-body">
          {/* Executive Summary Card */}
          <div className="susan-report-summary-card">
            <div className="susan-summary-header">
              <h3 className="susan-summary-title">Executive Summary</h3>
              <div className="susan-report-score">
                <span className="susan-score-value">{selectedReport.score}</span>
                <span className="susan-score-label">Security Score</span>
              </div>
            </div>
            
            <div className="susan-summary-meta">
              <div className="susan-meta-item">
                <div className="susan-meta-icon">🕒</div>
                <div className="susan-meta-content">
                  <span className="susan-meta-label">Generated</span>
                  <span className="susan-meta-value">
                    {new Date(selectedReport.timestamp).toLocaleString()}
                  </span>
                </div>
              </div>
              
              <div className="susan-meta-item">
                <div className="susan-meta-icon">📊</div>
                <div className="susan-meta-content">
                  <span className="susan-meta-label">Total Insights</span>
                  <span className="susan-meta-value">
                    {selectedReport.insights?.length || 0}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Recommended Modules Section */}
          {selectedReport.recommendedModules?.length > 0 && (
            <div className="susan-report-section">
              <div className="susan-section-header">
                <h3 className="susan-section-title">
                  <span className="susan-section-icon">📌</span>
                  Recommended Security Modules
                </h3>
              </div>
              
              <div className="susan-modules-grid">
                {selectedReport.recommendedModules.map((module, idx) => (
                  <div key={idx} className="susan-module-tag">
                    <span className="susan-module-name">{module}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Security Insights Section */}
          <div className="susan-report-section">
            <div className="susan-section-header">
              <h3 className="susan-section-title">
                <span className="susan-section-icon">🔍</span>
                Security Risk Analysis
              </h3>
              <span className="susan-insights-count">
                {selectedReport.insights?.length || 0} insights identified
              </span>
            </div>

            <div className="susan-insights-container">
              {selectedReport.insights?.length > 0 ? (
                selectedReport.insights.map((insight, index) => (
                  <div key={index} className="susan-insight-card">
                    <div 
                      className="susan-insight-header"
                      onClick={() => toggleInsight(index)}
                    >
                      <div className="susan-insight-header-left">
                        <div className={`susan-severity-badge susan-severity-${insight.severity?.toLowerCase()}`}>
                          {insight.severity}
                        </div>
                        <h4 className="susan-insight-category">{insight.category}</h4>
                      </div>
                      
                      <button className={`susan-insight-toggle ${expandedIndex === index ? 'susan-expanded' : ''}`}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" />
                        </svg>
                      </button>
                    </div>

                    {expandedIndex === index && (
                      <div className="susan-insight-content">
                        <div className="susan-insight-detail">
                          <h5 className="susan-detail-label">Risk Assessment</h5>
                          <p className="susan-detail-text">{insight.risk}</p>
                        </div>
                        
                        <div className="susan-insight-detail">
                          <h5 className="susan-detail-label">Recommended Action</h5>
                          <p className="susan-detail-text">{insight.recommendation}</p>
                        </div>
                      </div>
                    )}
                  </div>
                ))
              ) : (
                <div className="susan-empty-state">
                  <div className="susan-empty-icon">📋</div>
                  <p className="susan-empty-message">No security insights available for this report.</p>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Footer Section */}
        <div className="susan-assessment-report-footer">
          <div className="susan-footer-actions">
            <button 
              className="susan-btn-secondary"
              onClick={() => setShowReportModal(false)}
            >
              Close
            </button>
            <button
              className="susan-btn-primary"
              onClick={() => handleDownloadReport(selectedReport)}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" className="susan-btn-icon">
                <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
              </svg>
              Download Report
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
)}



          {showReminderModal && (
            <div className="submit-popup-overlay">
              <div className="submit-popup-content">
                <h5>Set Reminder</h5>
                <p>
                  <strong>{selectedReminderItem?.category}</strong>:{" "}
                  {selectedReminderItem?.description}
                </p>

                <div className="mb-3">
                  <Button
                    variant="outline-secondary"
                    className="me-2"
                    onClick={() => setReminderDate(getFutureDate(14))}
                  >
                    In 2 Weeks
                  </Button>
                  <Button
                    variant="outline-secondary"
                    onClick={() => setReminderDate(getFutureDate(28))}
                  >
                    In 4 Weeks
                  </Button>
                </div>

                <input
                  type="datetime-local"
                  className="form-control mb-3"
                  value={reminderDate}
                  onChange={(e) => setReminderDate(e.target.value)}
                />

                <div className="d-flex justify-content-end">
                  <Button
                    variant="secondary"
                    className="me-2"
                    onClick={() => setShowReminderModal(false)}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="primary"
                    onClick={() => handleSubmitReminder()}
                  >
                    Save Reminder
                  </Button>
                </div>
              </div>
            </div>
          )}
          {/* Download/Email Report Modal */}
{showDownloadModal && (
  <div className="submit-popup-overlay">
    <div className="submit-popup-content position-relative">
      <button
        className="btn-close position-absolute top-0 end-0 m-2"
        aria-label="Close"
        onClick={() => setShowDownloadModal(false)}
      ></button>

      <h5 className="text-primary mb-3">📄 Generate Report</h5>
      <p className="mb-4">
        Generate a comprehensive PDF report containing your security score, 
        AI insights, and recommended modules.
      </p>

      {/* Report Preview */}
      <div className="mb-4 p-3 bg-light rounded">
        <h6>Report will include:</h6>
        <ul className="mb-0">
          <li>Security Score: <strong>{scaledScore}%</strong></li>
          <li>Total Risks: <strong>{displayedRisks.length}</strong></li>
          <li>Critical Risks: <strong>{displayedRisks.filter(risk => risk.severity === "Critical").length}</strong></li>
          <li>AI Insights and Recommendations</li>
          <li>Recommended Security Modules</li>
        </ul>
      </div>

      <div className="d-flex justify-content-end gap-2">
        <Button
          variant="secondary"
          onClick={() => setShowDownloadModal(false)}
          disabled={isGeneratingReport}
        >
          Cancel
        </Button>
        
        <Button
          variant="outline-primary"
          onClick={handleEmailPDF}
          disabled={isGeneratingReport || !userData?.email}
        >
          {isGeneratingReport ? (
            <>
              <Spinner animation="border" size="sm" className="me-2" />
              Emailing...
            </>
          ) : (
            <>📧 Email Report</>
          )}
        </Button>
        
        <Button
          variant="primary"
          onClick={handleDownloadPDF}
          disabled={!displayedRisks.length}
        >
          {isGeneratingReport ? (
            <>
              <Spinner animation="border" size="sm" className="me-2" />
              Generating...
            </>
          ) : (
            <>💾 Download PDF</>
          )}
        </Button>
      </div>

      {!userData?.email && (
        <div className="mt-3 text-warning">
          <small>⚠️ Email address not available for email option</small>
        </div>
      )}
    </div>
  </div>
)}

{/* Email Report Modal */}
{showEmailModal && (
  <div className="submit-popup-overlay">
    <div className="submit-popup-content position-relative">
      <button
        className="btn-close position-absolute top-0 end-0 m-2"
        aria-label="Close"
        onClick={() => setShowEmailModal(false)}
      ></button>

      <h5 className="text-primary mb-3">📧 Email Security Report</h5>
      <p className="mb-3">
        Enter the email address where you want to send the PDF report.
      </p>

      <Form.Group className="mb-3">
        <Form.Label>Email Address</Form.Label>
        <Form.Control
          type="email"
          placeholder="Enter email address"
          value={emailAddress}
          onChange={(e) => setEmailAddress(e.target.value)}
          isInvalid={emailAddress && !emailAddress.includes('@')}
        />
        <Form.Control.Feedback type="invalid">
          Please enter a valid email address
        </Form.Control.Feedback>
      </Form.Group>

      <div className="d-flex justify-content-end gap-2">
        <Button
          variant="secondary"
          onClick={() => setShowEmailModal(false)}
          disabled={isGeneratingReport}
        >
          Cancel
        </Button>
        
        <Button
          variant="primary"
          onClick={sendEmailReport}
          disabled={isGeneratingReport || !emailAddress}
        >
          {isGeneratingReport ? (
            <>
              <Spinner animation="border" size="sm" className="me-2" />
              Sending Email...
            </>
          ) : (
            <>📧 Send Report</>
          )}
        </Button>
      </div>
    </div>
  </div>
)}


        </Col>
         <BackgroundFooter isSidebarCollapsed={isSidebarCollapsed}  />
       </Col>
      
      </Row>
{/* Share Dashboard Modal - Enhanced */}
{showShareModal && (
  <div className="submit-popup-overlay">
<div className="submit-popup-content share-dashboard-modal">  
 
  <div className="share-dashboard-header">
     <button
        className="btn-close  "
        // style={{ zIndex: 10 }}
        aria-label="Close"
        onClick={() => {
          setShowShareModal(false);
          setShareEmail('');
        }}
      />
      <div className="text-center w-100">
      <h5 className="text-primary mb-3">
        Share Dashboard
      </h5>
     
      <p className="mb-4">
  Share your dashboard data with another user. Select what information to include.
</p>
</div>
</div>
 
<div className="share-dashboard-body">  
  <div
          className="alert alert-info mb-3"
          style={{ fontSize: '0.875rem' }}
        >
  <strong >Live Sync:</strong>
  Recipients will always see your latest data in real-time.
</div>
 
     
      {/* Share Options - What to Share */}
      <div className="mb-4">
        <h6 className="text-secondary mb-3">
          Select Data to Share
        </h6>
       
        <div className="border rounded p-3" style={{ backgroundColor: '#f8f9fa' }}>
          <Form.Check
            type="checkbox"
            id="share-risk-register"
            label={
              <div>
                <strong>Risk Register</strong>
                <small className="d-block text-muted">
                  All identified risks with severity, recommendations, and affected assets
                </small>
              </div>
            }
            checked={shareOptions.riskRegister}
            onChange={(e) => setShareOptions({ ...shareOptions, riskRegister: e.target.checked })}
            className="mb-3"
          />
         
          <Form.Check
            type="checkbox"
            id="share-security-score"
            label={
              <div>
                <strong>Security Score & Trends</strong>
                <small className="d-block text-muted">
                  Current score, historical trends, and section-wise breakdown
                </small>
              </div>
            }
            checked={shareOptions.securityScore}
            onChange={(e) => setShareOptions({ ...shareOptions, securityScore: e.target.checked })}
            className="mb-3"
          />
         
          <Form.Check
            type="checkbox"
            id="share-recommended-modules"
            label={
              <div>
                <strong>Recommended Modules</strong>
                <small className="d-block text-muted">
                  AI-recommended security modules and compliance frameworks
                </small>
              </div>
            }
            checked={shareOptions.recommendedModules}
            onChange={(e) => setShareOptions({ ...shareOptions, recommendedModules: e.target.checked })}
            className="mb-3"
          />
         
          <Form.Check
            type="checkbox"
            id="share-avoidable-loss"
            label={
              <div>
                <strong>Estimated Avoidable Loss</strong>
                <small className="d-block text-muted">
                  Financial impact analysis and asset inventory data
                </small>
              </div>
            }
            checked={shareOptions.avoidableLoss}
            onChange={(e) => setShareOptions({ ...shareOptions, avoidableLoss: e.target.checked })}
            className="mb-3"
          />
         
          <Form.Check
            type="checkbox"
            id="share-third-party"
            label={
              <div>
                <strong>Third-Party Collaboration</strong>
                <small className="d-block text-muted">
                  Vendor relationships, compliance status, and third-party risks
                </small>
              </div>
            }
            checked={shareOptions.thirdPartyCollaboration}
            onChange={(e) => setShareOptions({ ...shareOptions, thirdPartyCollaboration: e.target.checked })}
            className="mb-3"
          />
         
          <Form.Check
            type="checkbox"
            id="share-internal-invites"
            label={
              <div>
                <strong>Internal Invites</strong>
                <small className="d-block text-muted">
                  Team collaboration invites and access management
                </small>
              </div>
            }
            checked={shareOptions.internalInvites}
            onChange={(e) => setShareOptions({ ...shareOptions, internalInvites: e.target.checked })}
            className="mb-3"
          />
         
          <Form.Check
            type="checkbox"
            id="share-reporting"
            label={
              <div>
                <strong>Reporting & History</strong>
                <small className="d-block text-muted">
                  Assessment history and uploaded reports
                </small>
              </div>
            }
            checked={shareOptions.reporting}
            onChange={(e) => setShareOptions({ ...shareOptions, reporting: e.target.checked })}
          />
        </div>
       
        {/* Select All / Deselect All */}
        <div className="marginTopSelectedButton d-flex gap-2">
          <Button
            variant="link"
            size="sm"
            onClick={() => setShareOptions({
              riskRegister: true,
              recommendedModules: true,
              securityScore: true,
              avoidableLoss: true,
              thirdPartyCollaboration: true,
              internalInvites: true,
              reporting: true
            })}
          >
            Select All
          </Button>
          <Button
            variant="link"
            size="sm"
            onClick={() => setShareOptions({
              riskRegister: false,
              recommendedModules: false,
              securityScore: false,
              avoidableLoss: false,
              thirdPartyCollaboration: false,
              internalInvites: false,
              reporting: false
            })}
          >
            Deselect All
          </Button>
        </div>
      </div>
     
      <hr />
 
 
 
 
 
     
      {/* Share Form */}
      <Form.Group className="mb-4">
        <Form.Label>Recipient Email Address</Form.Label>
        <div className="d-flex gap-2">
          <Form.Control
            type="email"
            placeholder="Enter email address"
            value={shareEmail}
            onChange={(e) => setShareEmail(e.target.value)}
            isInvalid={shareEmail && !shareEmail.includes('@')}
          />
          <Button
            variant="primary"
            onClick={handleShareDashboard}
            disabled={
              sharingInProgress ||
              !shareEmail ||
              !Object.values(shareOptions).some(v => v) // At least one option selected
            }
          >
            {sharingInProgress ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Sharing...
              </>
            ) : (
              <>
                Share
              </>
            )}
          </Button>
        </div>
        <Form.Control.Feedback type="invalid">
          Please enter a valid email address
        </Form.Control.Feedback>
        {!Object.values(shareOptions).some(v => v) && (
          <Form.Text className="text-danger">
            Please select at least one data category to share
          </Form.Text>
        )}
      </Form.Group>
     
      <hr />
     
      {/* Shared Users List */}
      <div className="mb-3">
        <h6 className="text-primary mb-3">
          Shared With ({sharedUsers.length})
        </h6>
       
        {loadingSharedUsers ? (
          <div className="d-flex align-items-center justify-content-center py-4">
            <Spinner animation="border" variant="primary" size="sm" className="me-2" />
            <span className="text-muted">Loading shared users...</span>
          </div>
        ) : sharedUsers.length > 0 ? (
          <div className="list-group">
            {sharedUsers.map((user, idx) => (
              <div
                key={idx}
                className="list-group-item d-flex justify-content-between align-items-start"
              >
                <div className="flex-fill">
                  <div className="fw-medium mb-1">
                    {user.email}
                  </div>
                  <small className="text-muted d-block mb-1">
                    Shared on {new Date(user.sharedAt).toLocaleDateString()} at{' '}
                    {new Date(user.sharedAt).toLocaleTimeString()}
                  </small>
                 
                  {/* Show what was shared */}
                  <div className="marginTopSelectedButton">
                    <small className="text-muted d-block mb-1">
                      <strong>Shared:</strong>
                    </small>
                    <div className="d-flex flex-wrap gap-1">
                      {user.shareOptions?.riskRegister && (
                        <span className="badge bg-info text-dark">Risk Register</span>
                      )}
                      {user.shareOptions?.securityScore && (
                        <span className="badge bg-success">Security Score</span>
                      )}
                      {user.shareOptions?.recommendedModules && (
                        <span className="badge bg-warning text-dark">Modules</span>
                      )}
                      {user.shareOptions?.avoidableLoss && (
                        <span className="badge bg-danger">Avoidable Loss</span>
                      )}
                      {user.shareOptions?.thirdPartyCollaboration && (
                        <span className="badge bg-secondary">Third Party</span>
                      )}
                      {user.shareOptions?.internalInvites && (
                        <span className="badge bg-primary">Internal Invites</span>
                      )}
                      {user.shareOptions?.reporting && (
                        <span className="badge bg-dark">Reporting</span>
                      )}
                    </div>
                  </div>
                </div>
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={() => handleUndoShare(user.shareId, user.email)}
                  className="ms-2"
                >
                  Remove
                </Button>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-4 text-muted">
            <p className="mb-0">Dashboard not shared with anyone yet</p>
          </div>
        )}
      </div>
     
      <div className="d-flex justify-content-end">
        <Button
          variant="secondary"
          onClick={() => {
            setShowShareModal(false);
            setShareEmail('');
          }}
        >
          Close
        </Button>
      </div>
    </div>
  </div>
  </div>
)}


{/* View Risk Side Panel */}
<Modal
  show={showRiskPanel}
  onHide={() => setShowRiskPanel(false)}
  dialogClassName="risk-drawer-dialog"
  backdrop={true}
  className="risk-drawer-modal"
>
  <Modal.Header closeButton className="risk-drawer-header border-0 Risk Context ">
    <div className="w-100">
      <div className="d-flex align-items-start justify-content-between gap-3">
        <div>
          <div className="risk-drawer-eyebrow">Risk register</div>
          <Modal.Title className="risk-drawer-title mb-2">
            Risk #{selectedRisk?.riskId}
          </Modal.Title>
          <div className="risk-drawer-subtitle">
            {selectedRisk?.category}
          </div>
        </div>

        <div className="d-flex flex-wrap justify-content-end gap-2 pe-4">
          <span className={`risk-chip risk-chip-severity risk-chip-${selectedRisk?.severity?.toLowerCase()}`}>
            {selectedRisk?.severity}
          </span>
          <span className="risk-chip risk-chip-status">
            {(selectedRisk?.status || "active").toUpperCase()}
          </span>
        </div>
      </div>
    </div>
  </Modal.Header>

  <Modal.Body className="risk-drawer-body framework-readiness-scroll ">
    {selectedRisk && (
      <div className="risk-drawer-content framework-readiness-scroll">

        {/* Summary cards */}
        <div className="risk-summary-grid">
          <div className="risk-summary-card">
            <span className="risk-summary-label">Owner</span>
            <span className="risk-summary-value">{selectedRisk.riskOwner || "Not assigned"}</span>
          </div>

          <div className="risk-summary-card">
            <span className="risk-summary-label">Domain</span>
            <span className="risk-summary-value">{selectedRisk.domain || selectedRisk.category}</span>
          </div>

          <div className="risk-summary-card">
            <span className="risk-summary-label">Next review</span>
            <span className="risk-summary-value">{selectedRisk.reviewDate || "—"}</span>
          </div>

          <div className="risk-summary-card">
            <span className="risk-summary-label">Confidence</span>
            <div className="risk-progress-wrap">
              <div className="risk-progress">
                <div
                  className="risk-progress-bar"
                  style={{ width: `${selectedRisk.confidence || 75}%` }}
                />
              </div>
              <span className="risk-progress-text">{selectedRisk.confidence || 75}%</span>
            </div>
          </div>
        </div>

        <RiskOwnerSection
          selectedRisk={selectedRisk}
          setSelectedRisk={setSelectedRisk}
          allRisks={allRisks}
          setAllRisks={setAllRisks}
          setShowToast={setShowToast}
          setToastMessage={setToastMessage}
          userData={userData}
        />

        {/* Context */}
        <section className="risk-section-card">
          <div className="risk-section-head">
            <h6>Risk Context</h6>
          </div>

          <div className="risk-detail-list">
            <div className="risk-detail-item">
              <span className="risk-detail-label">Asset affected</span>
              <p>{selectedRisk.assetAffected}</p>
            </div>

            <div className="risk-detail-item">
              <span className="risk-detail-label">Threat source</span>
              <p>{selectedRisk.threatSource}</p>
            </div>

            <div className="risk-detail-item">
              <span className="risk-detail-label">Description</span>
              <p>{selectedRisk.risk}</p>
            </div>

            <div className="risk-detail-item">
              <span className="risk-detail-label">Recommendation</span>
              <p>{selectedRisk.recommendation}</p>
            </div>
          </div>
        </section>

        {/* Scores */}
        <section className="risk-section-card">
          <div className="risk-section-head">
            <h6>Risk Scores</h6>
          </div>

          <div className="risk-score-grid">
            <div className="risk-score-card">
              <div
                className={`risk-score-orb ${
                  (selectedRisk.inherentRisk || 0) >= 20
                    ? "critical"
                    : (selectedRisk.inherentRisk || 0) >= 15
                    ? "high"
                    : (selectedRisk.inherentRisk || 0) >= 8
                    ? "medium"
                    : "low"
                }`}
              >
                {selectedRisk.inherentRisk || "—"}
              </div>
              <div className="risk-score-label">Inherent Risk</div>
            </div>

            <div className="risk-score-card">
              <div className="risk-coverage-ring">
                <CircularProgressbar
                  value={selectedRisk.controlCoverage || 0}
                  text={`${selectedRisk.controlCoverage || 0}%`}
                  styles={buildStyles({
                    textSize: "20px",
                    textColor: "#035EA5",
                    pathColor: "#035EA5",
                    trailColor: "#D9E5EF"
                  })}
                />
              </div>
              <div className="risk-score-label">Control Coverage</div>
            </div>

            <div className="risk-score-card">
              <div
                className={`risk-score-orb ${
                  (selectedRisk.residualRisk || 0) >= 20
                    ? "critical"
                    : (selectedRisk.residualRisk || 0) >= 15
                    ? "high"
                    : (selectedRisk.residualRisk || 0) >= 8
                    ? "medium"
                    : "low"
                }`}
              >
                {selectedRisk.residualRisk || "—"}
              </div>
              <div className="risk-score-label">Residual Risk</div>
              <div className="risk-score-subtext">{selectedRisk.residualRiskLevel || ""}</div>
            </div>
          </div>
        </section>

        {/* Linked controls */}
        <section className="risk-section-card risk-controls-card">
          <div className="risk-section-head">
            <h6>Linked Controls</h6>
            <span className="risk-section-meta">
              Coverage {selectedRisk.controlCoverage || 0}%
            </span>
          </div>

          {(selectedRisk.linkedControls && selectedRisk.linkedControls.length > 0) ? (
            <>
              <div className="risk-control-list">
                {selectedRisk.linkedControls.map((ctrl, idx) => (
                  <div key={idx} className="risk-control-row">
                    <div className={`risk-control-dot ${ctrl.status || "not_started"}`} />
                    <div className="risk-control-main">
                      <button
                        type="button"
                        className="risk-control-link"
                        onClick={() => {
                          setShowRiskPanel(false);
                          navigate(`/trust/control/${ctrl.controlId}`);
                        }}
                      >
                        {ctrl.controlId}
                      </button>
                      <div className="risk-control-name">{ctrl.controlName}</div>
                    </div>

                    <div className={`risk-control-maturity ${ctrl.status || "not_started"}`}>
                      {ctrl.maturity || "0%"}
                    </div>
                  </div>
                ))}
              </div>

              <button
                type="button"
                className="risk-add-control-btn"
                onClick={() => {
                  setShowControlPicker(true);
                  setControlPickerRiskId(selectedRisk.riskId);
                  if (allControls.length === 0) {
                    fetchAllControlsForPicker();
                  }
                }}
              >
                + Map new control
              </button>

              {showControlPicker && controlPickerRiskId === selectedRisk.riskId && (
                <div className="risk-picker-box">
                  {loadingControls ? (
                    <div className="risk-picker-loading">Loading controls...</div>
                  ) : (
                    <>
                      <select
                        className="risk-picker-select"
                        defaultValue=""
                        onChange={async (e) => {
                          const controlId = e.target.value;
                          if (!controlId) return;
                          const storeState = useTrustStore.getState();
                          try {
                            await storeState.addRiskMapping(controlId, {
                              riskId: String(selectedRisk.riskId),
                              riskName: selectedRisk.risk || "",
                              severity: selectedRisk.severity || "",
                              source: "Manual",
                              addedBy: userData?.email,
                              addedByUserId: userData?.["cognito:username"],
                            });

                            if (!selectedRisk.linkedControls) selectedRisk.linkedControls = [];
                            selectedRisk.linkedControls.push({ controlId });

                            setShowControlPicker(false);
                            setControlPickerRiskId(null);
                          } catch (err) {
                            console.error("Failed to map control:", err);
                          }
                        }}
                      >
                        <option value="">Select a control...</option>
                        {allControls
                          .filter(
                            c => !selectedRisk.linkedControls?.some(lc => lc.controlId === c.controlId)
                          )
                          .map(c => (
                            <option key={c.controlId} value={c.controlId}>
                              {c.controlId} — {c.controlName || c.control}
                            </option>
                          ))}
                      </select>

                      <button
                        type="button"
                        className="risk-picker-cancel"
                        onClick={() => {
                          setShowControlPicker(false);
                          setControlPickerRiskId(null);
                        }}
                      >
                        Cancel
                      </button>
                    </>
                  )}
                </div>
              )}

              <div className="risk-coverage-bar-wrap">
                <div className="risk-coverage-bar">
                  <div
                    className="risk-coverage-bar-fill"
                    style={{ width: `${selectedRisk.controlCoverage || 0}%` }}
                  />
                </div>
              </div>
            </>
          ) : (
            <p className="risk-empty-text">
              No linked controls yet. Map a control to begin treatment.
            </p>
          )}
        </section>

        {/* Action buttons */}
        <div className="risk-action-bar">
          {selectedRisk?.linkedControls?.length > 0 ? (
            selectedRisk.linkedControls.map((ctrl, idx) => (
              <Button
                key={idx}
                className="risk-treat-btn"
                onClick={() => {
                  setShowRiskPanel(false);
                  navigate(`/trust/control/${ctrl.controlId}`);
                }}
                style={btnPrimary}
              >
                Treat in {ctrl.controlId}
              </Button>
            ))
          ) : (
            <span className="risk-empty-text">
              No linked controls — map a control first to treat this risk.
            </span>
          )}
        </div>
      </div>
    )}
  </Modal.Body>
</Modal> 

{showDeleteModal &&
  createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-sm">
      
      {/* Prevent click propagation */}
      <div 
        className="absolute inset-0"
        onClick={() => {
          setShowDeleteModal(false);
          setFileToDelete(null);
        }}
      />

      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md mx-4 overflow-hidden z-[10000]">
        
        {/* Header */}
        <div className="bg-red-50 px-6 py-5 flex items-center gap-4">
          <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center">
            <svg className="w-6 h-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-800">Delete File</h3>
            <p className="text-sm text-gray-500">This action cannot be undone</p>
          </div>
        </div>

        {/* Body */}
        <div className="px-6 py-5">
          <p className="text-gray-600 text-sm">
            You are about to permanently delete:
          </p>
          <div className="mt-3 flex items-center gap-3 bg-gray-50 border border-gray-200 rounded-lg px-4 py-3">
            <span className="text-sm font-medium text-gray-800 truncate">
              {fileToDelete?.fileName || fileToDelete?.name}
            </span>
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 bg-gray-50 flex justify-end gap-3">
          <button
            onClick={() => {
              setShowDeleteModal(false);
              setFileToDelete(null);
            }}
            className="px-5 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-100"
          >
            Cancel
          </button>

          <button
            onClick={handleDeleteFile}
            className="px-5 py-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700"
          >
            Delete File
          </button>
        </div>

      </div>
    </div>,
    document.body
  )
}
 
    </div>
    
    </>
  );
};

export default SecurityModel;
